export default {
    "demo_account": {
        "footerpoint1": "FXVIEW es el nombre comercial del grupo de empresas FXVIEW que consiste en:",
        "footerpoint2": "- Compañía matriz, Finvasia Securities Private Ltd, regulada por la Junta de Bolsa e Intercambio de la India (Licencia sin INZ000176037)",
        "footerpoint3": "- Charlgate Ltd, regulado por la Comisión de Bolsa y Valores de Chipre (Licencia no 367/18)",
        "footerpoint4": "- Charlgate SVG LLC (Reg. No. 1112 LLC 2021) con dirección registrada en el primer piso, First St Vincent Bank Ltd Building, James Street, Kingstown, Saint Vincent y las Granadines.",
        "footerpoint5": "- Nevea Services Ltd (Reg. No. 422664) con dirección registrada en 319, 28 de octubre Street, Kanika Business Center, Office 201B, Limassol 3105, Chipre.",
        "footerpoint6": "La compañía comercial es Nevea Services Ltd con dirección registrada en 319, 28 de octubre de Street, Kanika Business Center, Office 201B, Limassol 3105, Chipre. La compañía comercial proporciona contenido, servicios administrativos, procesamiento de pagos y servicios de custodia.",
        "footerpoint7": "Los clientes deben tener al menos 18 años para usar los servicios de FXView.",
        "footerpoint8": "El comercio de instrumentos complejos en el margen tiene un alto nivel de riesgo y puede no ser adecuado para todos los inversores. Antes de decidir comerciar, debe considerar cuidadosamente sus objetivos comerciales, nivel de experiencia y apetito de riesgo. Es posible que mantenga pérdidas que excedan su capital invertido y, por lo tanto, no debe depositar dinero que no puede permitirse perder. Asegúrese de comprender completamente los riesgos y cuide adecuado para administrarlos.",
        "footerpoint9": "Este sitio contiene enlaces a sitios web controlados o ofrecidos por terceros. FXVIEW no ha revisado y por la presente renuncia a la responsabilidad de cualquier información o materiales publicados en cualquiera de los sitios vinculados a este sitio. Al crear un enlace a un sitio web de terceros, FXView no respalda ni recomienda ningún producto o servicio ofrecido en ese sitio web. La información contenida en este sitio está destinada solo a fines informativos. Por lo tanto, no debe considerarse como una oferta o solicitud para ninguna persona en ninguna jurisdicción en la que tal oferta o solicitud no esté autorizada ni a cualquier persona a quien sea ilegal hacer dicha oferta o solicitud, ni considerada como recomendación Comprar, vender o tratar con cualquier comercio en particular. Si no está seguro de sus regulaciones comerciales locales, debe dejar este sitio de inmediato.",
        "footerpoint10": "Se le recomienda encarecidamente que obtenga asesoramiento financiero, legal y fiscal independiente antes de proceder con cualquier comercio. Nada en este sitio debe leerse o interpretarse como consejos constituyentes por parte de FXView o cualquiera de sus afiliados, directores, oficiales o empleados.",
        "footerpoint11": "Los servicios de FXView y la información en este sitio no están dirigidos a los residentes de Crimea, Cuba, Chipre, India, Irán, Corea del Norte, Sudán, Siria y Estados Unidos y no están destinados a distribuir o usar por, Cualquier persona en cualquier país o jurisdicción donde dicha distribución o uso sea contrario a la ley o regulación local.",
        "high_risk_warning": "Advertencia de alto riesgo",
        "open_a": "Abre un",
        "free_demo": "Prueba gratis",
        "account_on": "Cuenta",
        "mt4": "Metatrader 4",
        "mt5": "Metatrader 5",
        "act": "Acttrader",
        "or": "o",
        "register": "Registro",
        "login": "Acceso",
        "have_acc": "¿Tener una cuenta?",
        "register_form_otp_msg": "Se ha enviado PIN de una sola vez a su correo electrónico. Por favor, ingrese a continuación.",
        "register_form_open_an_account": "Abrir una cuenta",
        "register_form_will_take_minut": "Tomará menos de un minuto",
        "register_form_select_residence_country": "Seleccionar país de residencia",
        "register_form_email": "Dirección de correo electrónico",
        "register_form_pass": "Introducir la contraseña",
        "register_form_cpass": "confirmar Contraseña",
        "register_form_privacy_agree": "Al registrarse, acepta nuestro",
        "register_form_privacy_policy": "política de privacidad",
        "website_use": "Uso del sitio web",
        "cookies_policy": "Política de cookies",
        "refund_policy": "Politica de reembolso",
        "AML_policy": "Política de AML",
        "sub_heading1_our": "Nuestro",
        "sub_heading1_features": "Características",
        "sub_heading1_title": "Latar su potencial de negociación y conquistar el mercado con nuestras inmejorables condiciones comerciales.",
        "sub_heading1_sub_container1_in_depth": "En profundidad",
        "sub_heading1_sub_container1_learning": "Aprendiendo",
        "sub_heading1_sub_container1_description": "Mejore su negociación registrando a nuestros seminarios web gratuitos y aprenda de los expertos. Nuestros seminarios web están diseñados específicamente para aumentar el conocimiento de su mercado y perfeccionar sus habilidades comerciales.",
        "sub_heading1_sub_container2_risk_free": "Sin riesgo",
        "sub_heading1_sub_container2_trading": "Comercio",
        "sub_heading1_sub_container2_description": "Ya sea que sea nuevo en el comercio o ya un comerciante de Forex experimentado, descubra su destreza comercial en FXVIEW, con nuestra cuenta de demostración de Forex sin riesgos.",
        "sub_heading1_sub_container3_hundreds_of": "Cientos de",
        "sub_heading1_sub_container3_tradable_instruments": "instrumentos negociables",
        "sub_heading1_sub_container3_description": "Obtenga acceso a más de 500 productos comerciales que van desde FX hasta productos básicos, acciones, índices y activos digitales.",
        "sub_heading1_sub_container4_real_prices_with": "Precios reales con",
        "sub_heading1_sub_container4_fast_execution": "ejecución rápida",
        "sub_heading1_sub_container4_description": "Experimente el comercio en tiempo real, explore una gran cantidad de herramientas y estrategias, y agudice sus habilidades mientras se comercia en una cuenta de demostración completamente libre de riesgos.",
        "sub_heading2_frequently_asked": "Preguntas frecuentes",
        "sub_heading2_questions": "Preguntas",
        "sub_heading2_description": "Obtenga sus preguntas respondidas: su guía final.",
        "sub_heading2_more_info": "Más información",
        "sub_heading2_faq1_question": "¿Hay un límite de tiempo para usar una cuenta de demostración?",
        "sub_heading2_faq1_answer": "Puede usar la cuenta de demostración durante el tiempo que desee. La cuenta solo se desactiva si no hay actividad durante 30 días consecutivos.",
        "sub_heading2_faq2_question": "¿Puedo abrir múltiples cuentas de demostración con diferentes plataformas de comercio?",
        "sub_heading2_faq2_answer": "Sí tu puedes. No hay límite en el número de cuentas de demostración que uno puede abrir con diferentes plataformas.",
        "sub_heading2_faq3_question": "¿Cuál es la diferencia entre una demostración y una cuenta comercial en vivo?",
        "sub_heading2_faq3_answer": "Las cuentas de negociación en vivo deben financiarse con dinero real para colocar operaciones. Mientras que las cuentas de demostración se financian con dinero virtual para eliminar el riesgo de perder dinero real. Aparte de esto, las condiciones comerciales, las herramientas y las características son casi las mismas tanto para la demostración como para las cuentas en vivo.",
        "sub_heading2_faq4_question": "¿Cuál es la cantidad máxima que puedo comerciar en una cuenta de demostración?",
        "sub_heading2_faq4_answer": "Obtendrá $ 100,000 para comerciar en la cuenta de demostración. Esta cantidad se rellena una vez que el saldo se vuelve nula.",
        "sub_heading2_faq5_question": "¿Puedo practicar el comercio de CFD en una cuenta de demostración?",
        "sub_heading2_faq5_answer": "Sí, es libre de intercambiar cualquier instrumento que ofrecamos por el comercio en vivo en su cuenta de demostración.",
        "sub_heading2_faq6_question": "¿Puedo abrir múltiples cuentas de demostración?",
        "sub_heading2_faq6_answer": "Sí, puede abrir múltiples cuentas de demostración con diferentes plataformas. Pero solo se puede abrir una cuenta de demostración para cada tipo de cuenta.",
        "sub_heading2_faq7_question": "¿Existe una tarifa de inactividad en la cuenta de demostración?",
        "sub_heading2_faq7_answer": "No, no cobramos ninguna tarifa de inactividad, pero la cuenta de demostración se desactivará si no se usa durante 30 días consecutivos."
    },
    "financial_details": "Detalles financieros",
    "reg_step_one_point": "Si se emplea, especifique",
    "reg_step_one_point_two": "Ingresos anuales estimados (USD)",
    "reg_step_one_point_three": "Patrimonio neto estimado (USD)",
    "reg_step_one_point_four": "Fuente de fondos",
    "accountancy": "Contabilidad",
    "admin_secretarial": "Administrador/secretario",
    "auctions": "Subastas",
    "catering_hospitality": "Catering/hospitalidad",
    "creative_media": "Creativo/medios",
    "education": "Educación",
    "emergency_services": "Servicios de emergencia",
    "engineering": "Ingeniería",
    "financial_services": "Servicios financieros",
    "gas_petrol": "Gas/gas",
    "health_medicine": "Salud y Medicina",
    "army_industry": "Industria del ejército/ejército",
    "hr": "HORA",
    "insurance": "Seguro",
    "legal": "Legal",
    "leisure_tourism": "Turismo de ocio",
    "manufacturing": "Fabricación",
    "marketing_pr_advertising": "Marketing/PR/Publicidad",
    "pharmaceuticals": "Farmacéuticos",
    "precious_metals_Diamonds": "Metales/diamantes preciosos",
    "property_construction_real_state": "Construcción de propiedades/bienes raíces",
    "retail": "Minorista",
    "sales": "Ventas",
    "social_care_services": "Atención social/servicios",
    "telecommunications": "Telecomunicaciones",
    "transport_logistics": "Transporte/logística",
    "trust_charities_foundations": "Confianza/organizaciones benéficas/fundaciones",
    "virtual_currency": "Moneda virtual",
    "other_please_specify": "Otros (especificar)",
    "till_ten_thousand": "0-30,000",
    "till_fifty_thousand": "30,000-60,000",
    "till_one_lac": "60,000-100,000",
    "till_two_lac": "100,000-200,000",
    "above_two_lac": "Por encima de 200,000",
    "till_fiftythousand": "50,000-100,000",
    "till_three_lac": "100,000-300,000",
    "above_three_lac": "300,000+",
    "employment": "Empleo",
    "inheritance": "Herencia",
    "investment": "Inversión",
    "real_estate": "Bienes raíces",
    "savings": "Ahorros",
    "other": "Otro",
    "reg_step_three": "Probemos su experiencia comercial",
    "reg_step_three_point": "Como entidad regulada, debemos evaluar si tiene una comprensión adecuada para el comercio de productos apalancados. Complete detenidamente su prueba de adecuación, ya que sus respuestas se utilizarán para determinar si puede abrir una cuenta comercial en vivo con nosotros.",
    "start_test": "Prueba de inicio",
    "depMsz1": "Tiempo de procesamiento:",
    "depMsz2": "1 a 5 días hábiles",
    "depMsz3": "Tarifa:",
    "depMsz4": "0",
    "depMsz10": "Instantáneo 24/7",
    "MiniDepositAmount": "Monto del depósito mínimo",
    "DntSkill": "no tienes ninguna identificación de skrill, por favor",
    "depMsz12": "Para cambiar su identificación de Skrill",
    "netId": "ID de netteller:",
    "depMsz13": "¿No es la cuenta correcta de Neteller? Por favor",
    "depMsz14": "Para cambiar su identificación de Neteller",
    "Clickhere": "Haga clic aquí.",
    "DntNetteler": "No tienes ninguna identificación de netteller, por favor",
    "Tocreate": "crear.",
    "conPay": "Confirmar depósito",
    "depMsz15": "Asegúrese de que los detalles del depósito sean correctos. Si está satisfecho con todo, haga clic en el botón \"Fondo ahora\" para continuar. Tenga en cuenta que si realiza un retiro después de depositar en su cuenta, es probable que sus fondos sean devueltos al mismo método utilizado para depositar.",
    "accountId": "ID de la cuenta",
    "feeUsd": "Tarifa (USD)",
    "depositAmount": "Cantidad del depósito",
    "paymentMethod": "Método de depósito",
    "backToStep": "Paso anterior",
    "procToPay": "Proceder al pago",
    "personalInfo": "Informacion personal",
    "fname": "Nombre de pila",
    "lname": "Apellido",
    "InvalidNumber": "Número invalido",
    "saveContinue": "Guardar Continuar",
    "termsAgreeRqd": "Acuerde los términos para continuar",
    "googleOtp": "Ingrese el código de acceso único que se muestra en la aplicación <strong> Google Authenticator </strong>.",
    "enterAmount": "Ingresar la cantidad",
    "allowDeposit1lac": "No estamos permitiendo depositar más de 1,00,000 para la cuenta de demostración",
    "SearchSomething": "Busca aquí",
    "search": "Buscar",
    "Prev": "Previsamente",
    "Next": "Próximo",
    "PleaseEnsureCorrect": "Asegúrese de que los detalles sean correctos",
    "lg_riskWarningMsg": "Los CFD son instrumentos complejos y tienen un alto riesgo de perder dinero rápidamente debido al apalancamiento. La gran mayoría de las cuentas de los clientes minoristas pierden dinero al comerciar en CFD. Debe considerar si comprende cómo funciona los CFD y si puede permitirse correr el alto riesgo de perder su dinero.",
    "lg_welcomeMsgHeadone": "Condiciones comerciales competitivas",
    "lg_welcomeMsg1": "Beneficiarse de diferenciales tan bajos como 0.0 pips en pares de FX principales y comisión de $ 1 por $ 100,000 por lado.",
    "lg_welcomeMsgHeadtwo": "Nuestras plataformas",
    "lg_welcomeMsg2": "Acceda a los mercados más populares del mundo en nuestras plataformas rápidas y confiables: MT4, MT5 y ActTrader",
    "lg_welcomeMsgHeadthree": "Herramientas de comercio",
    "lg_welcomeMsg3": "Acceda a una amplia gama de herramientas comerciales como Autochartist, Trader’s Tool Box, API Trading y más",
    "lg_signin": "Iniciar sesión en FXVIEW",
    "lg_emailaddress": "Dirección de correo electrónico",
    "lg_EmailfieldValid": "Por favor, introduce una dirección de correo electrónico válida",
    "lg_EmailfieldReq": "Se requiere el campo de correo electrónico",
    "lg_password": "Contraseña",
    "lg_logIn": "Iniciar sesión",
    "lg_forgotPassword": "Has olvidado tu contraseña",
    "lg_donthaveaccount": "¿No tienes una cuenta?",
    "lg_signuphere": "Registrate aquí",
    "lg_charlgateMsGlobal": "Finvasia Capital South Africa (PTY) Ltd Company registrada en Sudáfrica con el número de empresa 2018/303451/07. La dirección de la oficina registrada es 3rd Floor, 34 Whiteley Blvd, Melrose Arch, Birnam, 2196.",
    "lg_charlgateMsEurope": "Charlgate Ltd está autorizado y regulado por CYSEC, con el número de licencia 367/18 y el número de registro de la compañía 372060.",
    "lg_varify2step": "Verificación de dos pasos",
    "lg_EnterAuthCode": "Ingrese el código de autenticación",
    "lg_submit": "Entregar",
    "lg_backLogin": "Atrás para iniciar sesión",
    "lg_footerMsz2": "Su capital está en riesgo. Puede perder todo el capital invertido.",
    "lg_riskDisclaimer": "Descargo de responsabilidad de riesgos",
    "fp_forgotPasswordText": "Ingrese su dirección de correo electrónico registrada con FXView para que podamos ayudarlo a crear una nueva contraseña.",
    "fp_resetPassword": "Restablecer la contraseña",
    "fp_RESEND_EMAIL": "Reenviar email",
    "fp_backLogin": "Volver a iniciar sesión en la página",
    "fp_charlgateMsg": "Charlgate Ltd posee fxview.com. Charlgate Ltd es una compañía autorizada y regulada por la Comisión de Bolsa y Valores de Chipre - CYSEC (Número de licencia CYSEC 367/18 y Número de registro de la compañía: 372060) y un miembro del Fondo de Compensación de Inversores (ICF).",
    "reg_welcomemsg1": "<h3> se extiende </h3> <p> de 0.0 pip </p>",
    "reg_welcomemsg2": "<h3> $ 1 por </h3> <p> $ 100k Comisión </p>",
    "reg_welcomemsg3": "<h3> una variedad de herramientas de comercio </h3> <p> </p>",
    "reg_welcomemsg4": "<h3> ultra </h3> <p> Ejecución rápida </p>",
    "reg_welcomemsg5": "<h3> 100%</h3> <p> Bonificación de depósito",
    "reg_openacc": "Abrir una cuenta",
    "reg_takeminute": "Tomará menos de un minuto",
    "reg_selectacctype": "Seleccione Tipo de cuenta",
    "reg_selectcountry": "Seleccionar país de residencia",
    "reg_Enterfname": "Ingrese el nombre",
    "reg_Enterlname": "Introduzca el apellido",
    "reg_Entername": "Introduzca su nombre",
    "reg_Enteremail": "Introducir la dirección de correo electrónico",
    "reg_Enterpwd": "Introducir la contraseña",
    "reg_passwordFieldReq": "Se requiere el campo de contraseña",
    "reg_passCharVal": "Su contraseña debe contener al menos 6 caracteres e incluir al menos 1 número, 1 carácter mayúscula y 1 carácter especial (!@#$%^*)",
    "reg_conPassword": "confirmar Contraseña",
    "reg_ConfpasswordReq": "Se requiere el campo Confirmar contraseña.",
    "reg_newConfFieldSame": "Las contraseñas introducidas no coinciden. Inténtalo de nuevo",
    "reg_captchaErr": "Captcha inválido",
    "reg_register": "Registro",
    "reg_signagree": "Al registrarse, acepta nuestro",
    "reg_privacyPolicy": " política de privacidad",
    "reg_haveAccount": "¿Tener una cuenta?",
    "reg_login": "Acceso",
    "reg_registerMsz2": "Se ha enviado PIN de una sola vez a su correo electrónico. Por favor, ingrese a continuación.",
    "reg_enterOtp": "Ingrese OTP",
    "reg_submit": "Entregar",
    "reg_resendotp": "Reiniciar OTP",
    "rp_passwordHashMsz2": "La contraseña se ha cambiado correctamente. Hacer clic",
    "rp_here": "Aquí",
    "rp_toLogin": "iniciar sesión",
    "rp_otherWayHelp": "Otras formas de obtener ayuda",
    "rp_chatWithUs": "habla con nosotros",
    "rp_or": "o",
    "rp_callUs": "Llámenos",
    "prof_verified": "Verificado",
    "prof_undrreview": "¡Su aplicación está en revisión!",
    "prof_checkstatus": "Por favor revise el estado de su boleto",
    "prof_clickhere": "Haga clic aquí",
    "prof_completeRegister": "Registro completo",
    "prof_basicDetail": "Información básica",
    "prof_addressDetail": "Información de la dirección",
    "prof_paymentDetail": "Detalles del pago",
    "prof_documents": "Documentos",
    "prof_fname": "Nombre de pila",
    "prof_lname": "Apellido",
    "prof_DOB": "Fecha de nacimiento",
    "prof_phone": "Teléfono",
    "prof_Member": "Miembro",
    "prof_companyname": "nombre de empresa",
    "prof_incorporationdate": "Fecha de incorporación",
    "prof_currency": "Divisa",
    "prof_emailaddress": "Dirección de correo electrónico",
    "prof_PEP": "Persona políticamente expuesta (PEP)",
    "prof_addressLine1": "Línea de dirección residencial 1",
    "prof_addressLine2": "Línea de dirección residencial 2",
    "prof_postCode": "Código postal",
    "prof_city": "Ciudad o pueblo",
    "prof_resCountry": "País de residencia",
    "prof_bankName": "Nombre del banco:",
    "prof_AccNumber": "Número de cuenta:",
    "prof_Pending": "Pendiente",
    "prof_Disable": "Desactivar",
    "prof_viewDetail": "Ver Detalle",
    "prof_paymentMethod": "Método de depósito",
    "prof_AccountName": "Nombre de la cuenta",
    "prof_SwiftCode": "Código Swift/Bic/Sort",
    "prof_IBAN": "Iban",
    "prof_bankAdd": "Dirección bancaria:",
    "prof_onlinePayId": "ID de pago en línea:",
    "prof_Change": "Cambiar",
    "prof_CreditCard": "Número de Tarjeta de Crédito:",
    "prof_ExpiryDate": "Fecha de caducidad:",
    "prof_noBankDetail": "Sin datos bancarios",
    "prof_AddBank": "Agregar banco",
    "prof_AddCard": "Agregar tarjeta de crédito",
    "prof_noDocuments": "Sin documentos",
    "prof_disablecard": "Desactive amablemente el método de pago de mi tarjeta de crédito, información como se da a continuación:",
    "prof_creditcardno": "Número de Tarjeta de Crédito : **** **** ****",
    "prof_bankpaymentmethod": "Desactive amablemente mi método de pago de transferencia bancaria, información como se da a continuación:",
    "prof_diablepaymentmethod": "Desactivar el método de pago",
    "prof_addpeymentmethod": "Añadir método de pago",
    "twoFA_faText": "Autenticación de dos factores",
    "twoFA_alreadyEnabled": "Activado",
    "twoFA_setUp2FA": "Configurar 2FA",
    "twoFA_clickToDisable": "Haga clic para deshabilitar",
    "twoFA_clickToEnable": "Haga clic para habilitar",
    "twoFA_enable2FaText": "Habilitar la autenticación de dos factores",
    "twoFA_accounntSafe3Steps": "Haga que su cuenta sea más segura en 3 sencillos pasos:",
    "twoFA_downloaduthApp": "Descargar una aplicación de autenticador",
    "twoFA_downloaduthAppText": "Descargue e instale Authy o Google Authenticator en su teléfono o tableta.",
    "twoFA_scanQrCode": "Escanear el código QR",
    "twoFA_scanQrCodeText": "Abra la aplicación de autenticación y escanee la imagen a la izquierda, utilizando la cámara de su teléfono.",
    "twoFA_loginYourCode": "Inicie sesión con su código",
    "twoFA_enter6DigitCode": "Ingrese el código de verificación de 6 dígitos generado.",
    "twoFA_activate": "Activar",
    "twoFA_enterOtpDisableQrCode": "Ingrese OTP para deshabilitar el código QR",
    "twoFA_disableCodeText": "Deshabilitar con su código",
    "cp_changePassword": "Cambiar la contraseña",
    "cp_oldpwd": "Contraseña anterior",
    "cp_newPassword": "Nueva contraseña",
    "cp_conPassword": "Confirmar Contraseña",
    "cp_passCharval": "Su contraseña debe contener al menos 6 caracteres, máximo 15 caracteres e incluir al menos 1 número, 1 carácter mayúscula y 1 carácter especial (!@#$%^*)",
    "welcm_fewStepAway": "Estás a solo unos pasos de distancia",
    "welcm_activateFxviewAccountNow": "¡Active su cuenta FXView ahora!",
    "welcm_setupFxViewAcc": "Configurar su cuenta FXView",
    "welcm_modify": "Modificar",
    "welcm_addFund": "Añadir fondos",
    "welcm_startTrading": "Comienza a negociar",
    "welcm_welcomeFxView": "¡Bienvenido a FXView!",
    "welcm_welFxviewCon": "Estás casi listo para comenzar a comerciar. Complete su solicitud de cuenta comercial y cargue los documentos de identificación necesarios.",
    "welcm_completeReg": "Registro completo",
    "welcm_tryDemoAcc": "Prueba una cuenta de demostración",
    "welcm_tryDemoAccCon": "Pruebe nuestras plataformas comerciales - MT4, MT5 y ActTrader - y desarrolle sus habilidades comerciales de CFD. Practicar el comercio con fondos virtuales",
    "welcm_createDemoAccount": "Cuenta de demostración",
    "welcm_downloadPlatform": "Plataforma de descarga",
    "welcm_MT4": "Meta Trader 4",
    "welcm_winIosAndroid": "Windows/iOS/Android",
    "welcm_MT5": "Meta Trader 5",
    "welcm_actTrader": "ActTrader <Sup> tm </sup>",
    "welcm_rangeTradTools": "Gama de herramientas comerciales",
    "welcm_wlcmMsz1": "Identifique ideas comerciales generadas automáticamente basadas en patrones de gráficos, brotes, reversiones de tendencias, patrones de fibonacci e indicadores técnicos.",
    "welcm_wlcmMsz2": "Explore una amplia gama de ideas comerciales procesables reconocidas sobre la base de múltiples patrones de gráficos e indicadores técnicos en diversos activos.",
    "welcm_wlcmMsz3": "Mantén un paso adelante con las noticias financieras y actualizaciones en tiempo real sobre eventos geopolíticos para tomar decisiones comerciales informadas.",
    "welcm_wlcmMsz4": "Manténgase al día con el calendario económico en tiempo real que abarca eventos e indicadores económicos globales clave en el horizonte.",
    "welcm_wlcmMsz5": "Obtenga una experiencia comercial inigualable a través del programa de alojamiento de VPS adecuado que le permite negociar ininterrumpidamente con una latencia reducida.",
    "welcm_SeeMore": "Ver más",
    "notif_Notification": "Notificación",
    "notif_noNewNotification": "No hay notificaciones nuevas",
    "verf_reqProcessing": "Procesamiento de solicitud ...",
    "verf_reqVerify": "Verificación de solicitud",
    "verf_dear": "Estimado",
    "verf_requestVerifyWith": "Su solicitud de retiro se ha procesado con éxito",
    "verf_backWithList": "Volver a la lista de retiros",
    "verf_reqFailed": "Solicitud fallida",
    "verf_msg": "Su solicitud de retiro ha sido fallado",
    "refer_Refera": "Referir un",
    "refer_friend": "Amigo",
    "refer_opportunity": "Nuestro programa de referencia de un amigo le brinda la oportunidad de ganar $ 20 por cada amigo a los que se refiera. Además, su amigo también será recompensado $ 20 cuando se registre con su correo electrónico de invitación.",
    "refer_Refernow": "Referirse ahora",
    "refer_howorks": "Cómo funciona",
    "refer_everyclient": "Por cada cliente que se refiera, lo recompensaremos con $ 20. Comparta sus cosas favoritas sobre FXView con sus amigos y disfruta de un margen comercial adicional, sobre nosotros.",
    "refer_stepmsg1": "Regístrese o inicie sesión en su cuenta FXView",
    "refer_stepmsg2": "Invite a su amigo usando el formulario en el área del cliente",
    "refer_stepmsg3": "Su amigo recibirá una invitación por correo electrónico y seguirá los pasos para registrarse",
    "refer_stepmsg4": "Tanto usted como su amigo recibirán $ 20 una vez que usted y su amigo financien su cuenta con $ 200 o más",
    "refer_referEmail": "Correo electrónico referido",
    "refer_addmore": "Añadir más",
    "refer_nowrefer": "referirse ahora",
    "refer_successRefer": "Te has referido con éxito",
    "refer_refrMore": "Referir más",
    "refer_godashboard": "Ir al panel de control",
    "refer_partnerprog": "Nuestro otro programa de asociación",
    "refer_Affilialte": "programa de afiliación",
    "refer_uniquelink": "Obtenga su enlace de referencia único",
    "refer_trackearn": "Rastree sus ganancias de las referencias",
    "refer_monitorStatus": "Monitorear el estado de sus referencias",
    "refer_withdrawearn": "Retire sus ganancias como desee",
    "refer_register": "Registro",
    "refer_knowmore": "Saber más",
    "refer_brokerprogram": "Presentación del programa Broker",
    "refer_uniqueIB": "Portal IB único",
    "refer_IBmanager": "Gerente de IB dedicado",
    "refer_controlearn": "Tome el control de sus ganancias",
    "refer_regislink": "enlace de registro IB único",
    "refer_clientlist": "Lista de clientes",
    "refer_email": "Correo electrónico",
    "refer_accountStatus": "Etapa de cuenta",
    "refer_volumereq": "Requisito de volumen",
    "refer_tradedvol": "Volumen negociado",
    "refer_qualified": "Calificado",
    "refer_action": "Acción",
    "refer_successDelete": "Has eliminado con éxito",
    "refer_fromReflist": "de su lista de referencias",
    "refer_wantTodelete": "Quieres borrar",
    "refer_confrm": "Confirmar",
    "refer_enterEmailrefer": "Ingrese el correo electrónico para referirse",
    "refer_error": "error",
    "refer_errorReferal": "Debe ser verificado y financiado antes de la referencia.",
    "dash_overview": "Descripción general",
    "dash_traderRoom": "Habitación del comerciante",
    "dash_personalInfo": "Informacion personal",
    "dash_declaration": "Declaración",
    "dash_uploadDocumen": "Subir documentos personales",
    "dash_completeReg": "Registro completo",
    "dash_checkticketstatus": "Verifique el estado de su boleto.",
    "dash_clickhere": "Haga clic aquí",
    "dash_TradingAcc": "Cuentas comerciales",
    "dash_live": "Vivir",
    "dash_demo": "Manifestación",
    "dash_Platform": "Plataforma",
    "dash_tradAccId": "ID de la cuenta",
    "dash_Leverage": "Aprovechar",
    "dash_currency": "Divisa",
    "dash_marketSummary": "Resumen del mercado",
    "dash_marketInsight": "Ideas del mercado",
    "dash_news": "Noticias",
    "dash_EconomicCal": "Calendario económico",
    "dash_thereIsNoRecord": "No se encontraron registros",
    "dash_Time": "Tiempo",
    "dash_Country": "País",
    "dash_event": "Evento",
    "dash_frequency": "Frecuencia: mensual",
    "dash_autochartist": "Autoquistista",
    "dash_nodata": "Sin datos",
    "dash_time": "Tiempo",
    "dash_impact": "Impacto",
    "dash_actual": "Actual",
    "dash_forecast": "Pronóstico",
    "dash_previous": "Anterior",
    "dp_download": "Descargar",
    "dp_actTrader": "ActTrader <Sup> tm </sup>",
    "dp_forWindows": "Para ventanas",
    "dp_forIos": "Para iOS",
    "dp_forAndroid": "Para Android",
    "dp_ActWebTrader": "Comerciante web de ACT",
    "dp_MT4WebTrader": "Comerciante web MT4",
    "dp_forMAC": "Para Mac",
    "dp_MT5WebTrader": "Comerciante web MT5",
    "forWindows": "Windows",
    "forIos": "iOS",
    "WEB": "Web",
    "acc_Aclist": "Lista de cuentas",
    "acc_changeLeverage": "Cambio de apalancamiento",
    "acc_changeplatPass": "Cambiar contraseña de plataforma",
    "acc_InternalTrans": "Transferencia interna",
    "bnk_bankDetails": "Detalles del banco",
    "bnk_MicrCode": "Código micr:",
    "bnk_IBANNumber": "Número de cuenta de Iban",
    "bnk_ifscSwiftBic": "IFSC/SWIFT/BIC (código corto del Reino Unido)",
    "bnk_Save": "Ahorrar",
    "db_requestBon": "Bono de solicitud",
    "db_removeBon": "Eliminar la bonificación",
    "db_bonusList": "Lista de bonos",
    "bver_bonusVerMsz1": "Su solicitud de bonificación se ha procesado con éxito.",
    "bver_backBonusList": "Volver a la lista de bonos",
    "bver_reqFailed": "Solicitud fallida",
    "bl_bonusList": "Lista de bonos",
    "bl_created": "Fecha",
    "bl_amount": "Cantidad",
    "bl_bonusType": "Tipo de bonificación",
    "bl_status": "Estado",
    "bl_comments": "Comentario",
    "bl_complete": "Completo",
    "bl_pending": "Pendiente",
    "rb_removeBonus": "Eliminar la bonificación",
    "rb_removebonusMsz1": "Lo siento, no es elegible para eliminar la bonificación.",
    "rb_availbonus": "Bonificación disponible:",
    "rb_bonusremove": "Ingrese la cantidad de bonificación para eliminar",
    "rb_submit": "Entregar",
    "rb_googleAuth1": "Ingrese el pin único de 6 dígitos que se muestra en el",
    "rb_googleAuth2": "Autenticador de Google",
    "rb_googleAuth3": "aplicación",
    "rb_validate": "Validar",
    "rb_googleAuth4": "¿Tiene problemas con su código de autenticación de dos factores?",
    "rb_googleAuth5": "Haga clic aquí para verificar con el correo electrónico",
    "rb_googleAuth6": "Hemos enviado un enlace a su correo electrónico",
    "rb_bonusGoogleAuth": "Por favor, haga clic en el enlace para continuar con su retiro",
    "rb_googleAuth7": "¿No ha recibido un correo electrónico en su bandeja de entrada o carpeta de spam? Revender",
    "rb_googleAuth8": "La autenticación de dos factores no está habilitada en su cuenta.",
    "rb_googleAuth9": "La autenticación de dos factores agrega una capa adicional de seguridad, asegurando que realmente sea usted quien está tratando de hacer cambios en su cuenta FXView.",
    "rb_googleAuth10": "Haga clic aquí para habilitar la autenticación de Google",
    "rb_congo": "Felicidades",
    "rb_removeBonusCongoMsz": "La bonificación se ha eliminado con éxito Fortading ID",
    "rb_goToDash": "Ir al panel de control",
    "rb_noTradingAccFound": "¡No se encontró una cuenta comercial en vivo!",
    "rb_plzWaitWhileProc": "Espere mientras procesemos sus datos ...",
    "rb_bonusGooglerequest": "Haga clic en el enlace amablemente para continuar con su solicitud de bonificación",
    "rb_bonusGoogleremove": "Haga clic en el enlace amablemente para continuar",
    "req_bonus": "Prima",
    "req_bonusMsz1": "Lo siento, no eres elegible. Fondo de su cuenta para aprovechar la bonificación.",
    "req_allowMaxBonus": "Bonificación máxima permitida",
    "req_amount": "Cantidad",
    "req_agreeTerms": "Estoy de acuerdo con los términos y condiciones",
    "reg_Agreee": "Estoy de acuerdo con la",
    "reg_TERMS": "Términos y condiciones",
    "req_fieldReq": "Se requiere campo",
    "req_maxlev": "El apalancamiento máximo se permite aprovechar el 100% de la bonificación de depósito es de 300x.",
    "req_tochangeleverage": "Para cambiar tu apalancamiento",
    "req_bonusMsz2": "La bonificación se ha agregado con éxito para la identificación de negociación:",
    "req_availBonus": "Use la bonificación",
    "req_allowBonus": "Bono permitido",
    "req_goBackMangeAcc": "Ir a administrar la cuenta",
    "req_noTradingAccFound": "¡No se encontró una cuenta comercial en vivo!",
    "req_minBonus": "La bonificación de depósito mínimo es de 200 dólares y estamos obteniendo la opción de depósito es",
    "req_maxAmount": "La cantidad máxima que puede solicitar bonificación es",
    "rb_ReadPolicy": "Lea nuestra política de bonificación",
    "dep_acc_fund_depFundAcc": "Depositar fondos para contabilizar",
    "dep_acc_fund_tradAccId": "ID de cuenta comercial",
    "dep_acc_fund_depFund": "Fondos de depósito",
    "dep_acc_fund_selDepMet": "Seleccionar el método de depósito",
    "dep_acc_fund_depFieldReq": "Se requiere campo de depósito",
    "dep_selectbankaccount": "Seleccione la cuenta bancaria:",
    "dep_acc_fund_lessDet": "Menos detalle",
    "dep_acc_fund_viewDet": "Ver Detalle",
    "dep_holderName": "Nombre del titular:",
    "dep_sortCode": "Código de clasificacion",
    "dep_reference": "Referencia",
    "dep_fortradaccount": "Para la cuenta comercial",
    "dep_selectAcc": "Seleccione la cuenta",
    "dep_acc_fund_DontbankAcc": "No tiene ninguna cuenta bancaria, por favor",
    "dep_acc_fund_clkHere": "Haga clic aquí",
    "dep_Createbank": "Para crear un nuevo banco",
    "dep_acc_fund_MinDepAmt": "Monto del depósito mínimo",
    "dep_acc_fund_SpeDepAm": "Especificar el monto del depósito",
    "dep_mindepositallow": "Depósito mínimo permitido",
    "dep_acc_fund_bakStp": "Paso anterior",
    "dep_acc_fund_procToPay": "Proceder al pago",
    "dep_ticketHasbeenCreated": "Tu boleto ha sido creado",
    "dep_proMsz19": "Ir a las entradas",
    "dep_acc_fund_PlsEnsCort": "Asegúrese de que los detalles sean correctos",
    "dep_acc_fund_accountId": "ID de cuenta/billetera No.",
    "dep_acc_fund_feeUsd": "Tarifa (USD)",
    "dep_acc_fund_depAmt": "Cantidad del depósito",
    "dep_acc_fund_depMeth": "Método de depósito",
    "dep_acc_fund_noTrdAccFnd": "¡No se encontró una cuenta comercial en vivo!",
    "dep_acc_fund_plzWaitWhileProc": "Espere mientras procesemos sus datos ...",
    "dep_maxlimit": "ha elevado el límite máximo de transacción por mes",
    "dep_maxdeposit": "puede depositar la cantidad máxima =",
    "dep_pleaseDeposit": "Quiero depositar",
    "dep_pleaseDeposit1": "de Ban Bank Detalle como se menciona a continuación <br>",
    "dep_AccNumber": "Número de cuenta :",
    "dep_holdername": "<br> Nombre del titular:",
    "dep_bankname": "<br> Nombre del banco:",
    "dep_brsortCode": "<br> Código de clasificación:",
    "dep_brbankAdress": "<br> Dirección bancaria:",
    "dep_depositDone": "depósito realizado con éxito",
    "dep_depositFail": "Depósito fallido",
    "dl_depositList": "Lista de depósitos",
    "dl_transId": "ID de transacción",
    "dl_status": "Estado",
    "dl_Method": "Método",
    "dl_type": "Tipo",
    "dl_created": "Fecha",
    "dl_action": "Acción",
    "dt_depTransHist": "Historial de transacciones de depósito",
    "dt_payMeth": "Método de pago",
    "dt_clickToResolve": "Haga clic para resolver",
    "dw_acc_fund_selDepMet": "Seleccionar el método de depósito",
    "dw_acc_fund_depFieldReq": "Se requiere campo de depósito",
    "dw_selectaccount": "Seleccione la cuenta bancaria:",
    "dw_acc_fund_lessDet": "Menos detalle",
    "dw_acc_fund_viewDet": "Ver Detalle",
    "dw_holderName": "Nombre del titular:",
    "dw_bankName": "Nombre del banco:",
    "dw_bankAdd": "Dirección bancaria:",
    "dw_sortCode": "Código de clasificacion",
    "dw_reference": "Referencia",
    "dw_fortradingAcc": "Para la cuenta comercial",
    "dw_acc_fund_DontbankAcc": "No tiene ninguna cuenta bancaria, por favor",
    "dw_Createbank": "Para crear un nuevo banco",
    "dw_acc_fund_MinDepAmt": "Monto del depósito mínimo",
    "dw_acc_fund_SpeDepAm": "Especificar el monto del depósito",
    "dw_acc_fund_PlsEnsCort": "Asegúrese de que los detalles sean correctos",
    "dw_acc_fund_accountId": "ID de la cuenta",
    "dw_acc_fund_feeUsd": "Tarifa (USD)",
    "dw_acc_fund_depAmt": "Cantidad del depósito",
    "dw_acc_fund_depMeth": "Método de depósito",
    "dw_proMsz19": "Ir a las entradas",
    "dw_acc_fund_plzWaitWhileProc": "Espere mientras procesemos sus datos ...",
    "dw_bankCode": "<br> Código bancario:",
    "acc_reqProcessing": "Procesamiento de solicitud ...",
    "acc_accountVerMsz1": "la solicitud ha sido procesada con éxito",
    "acc_backAccountList": "Volver a la lista de cuentas",
    "acc_reqFailed": "Solicitud fallida",
    "acclist_myAccounts": "Mis cuentas",
    "acclist_liveAccount": "Cuentas en vivo",
    "acclist_demoAccount": "Cuentas de demostración",
    "lev_changeLeverage": "Cambio de apalancamiento",
    "lev_exsistLev": "Apalancamiento existente",
    "lev_newLev": "Nuevo apalancamiento",
    "lev_backManageAccount": "Volver para administrar la cuenta",
    "lev_levMsz1": "Haga clic en el enlace para cambiar su apalancamiento.",
    "lev_levMsz2": "El apalancamiento de su cuenta comercial se ha cambiado con éxito",
    "lev_tradingId": "Ideas comerciales",
    "lev_oldLev": "Viejo apalancamiento",
    "lev_goBackMangeAccv": "Ir a administrar la cuenta",
    "lev_noDemoLiveTradingAccFound": "¡No se encontró una cuenta comercial!",
    "lev_waitforVerf": "Espere la verificación.",
    "levPwd_passMsz1": "Haga clic en el enlace para cambiar su contraseña",
    "lePwd_passMsz2": "La contraseña de su cuenta comercial se ha cambiado con éxito",
    "lePwd_oldPassword": "Contraseña anterior",
    "Dlist_demoLive": "Demostración/en vivo",
    "Dlist_accountType": "Tipo de cuenta",
    "Dlist_leverage": "Aprovechar",
    "detch_detachaccount": "Cuenta de separar:",
    "detch_fourfive": "454579",
    "detch_pamMaster": "Pamm Master:",
    "detch_todd": "Todd Anderson",
    "detch_balance": "Balance",
    "detch_equity": "Equidad",
    "detch_freeMargin": "Margen libre",
    "detch_MarginUSed": "Margen utilizado",
    "detch_pnl": "PNL",
    "detch_two": "$ 2000",
    "detch_eight": "$ 800",
    "detch_twelve": "$ 1200",
    "detch_three": "$ 300",
    "detch_twofive": "$ -250",
    "detch_takenote": "Tome nota de los puntos a continuación",
    "detch_openPosition": "Todas las posiciones abiertas se cerrarán antes de separar la cuenta.",
    "detch_finalPnl": "El PNL final puede variar según las condiciones del mercado.",
    "detch_afterOpen": "Después de que se cierren los puestos abiertos, la gestión, el costo de suscripción, la tarifa de rendimiento se calculará y se deducirá de la cuenta, si corresponde.",
    "detch_terms": "Acepto los términos y condiciones anteriores",
    "detch_confirm": "Confirmar",
    "It_oneRecord": "Solo tienes un registro. Cree al menos una cuenta comercial o billetera más antes de intentar una transferencia interna",
    "It_liveAcc": "Cuenta en vivo",
    "It_wallet": "Billetera",
    "It_internalTransfer": "Transferencia interna",
    "It_confToTransfer": "Confirme para continuar",
    "It_back": "Atrás",
    "It_freeMargin": "Margen libre",
    "It_interTransSorryMsz": "Lamento que no tenga saldo para transferir el monto a otra cuenta comercial.",
    "It_transToAcc": "Transferir a la ID de cuenta",
    "It_fieldReq": "Se requiere campo",
    "It_currentBalance": "Saldo actual",
    "It_pleseEnterAmount": "Ingrese la cantidad",
    "It_submit": "Entregar",
    "It_intTransMsz2": "Haga clic en el enlace para confirmar su transferencia interna",
    "It_intTransMsz3": "La transferencia se ha completado con éxito",
    "It_fromTradId": "De la identificación de negociación",
    "It_towallet": "A la billetera",
    "It_toTradId": "A la identificación de negociación",
    "It_transferAmount": "Cantidad transferida",
    "It_backinternalTrans": "Volver a la transferencia interna",
    "It_interTransDeducted": "se deducirá de su",
    "It_depostotradAcc": "se depositará a su",
    "Itwallet_backwallet": "Volver a la billetera",
    "Itwallet_cancel": "Cancelar",
    "Itwallet_fromwal": "de la billetera",
    "Itwallet_towal": "A la billetera",
    "Itwallet_backtowallet": "Volver a la billetera",
    "sub_SubliveAcc": "Suscribir cuenta en vivo",
    "sub_subscribe": "Suscribir",
    "sub_backtradingTool": "Volver a la caja de herramientas de comercio",
    "sub_enterotp": "Ingrese OTP",
    "sub_validate": "Validar",
    "sub_resendOtp": "Reiniciar OTP",
    "sub_congo": "Felicidades",
    "sub_tradingId": "ID de negociación",
    "sub_addtradertool": "Agregue Agregar cuadro de herramienta de comerciante según los siguientes detalles <br> Account_ID:",
    "re_marketinsight": "Ideas del mercado",
    "re_news": "Noticias",
    "edu_learnTrade": "Aprender a comerciar",
    "edu_offerEdu": "Le ofrecemos recursos educativos para aprender todo sobre el comercio. Nuestros materiales de aprendizaje atienden a todos los niveles de conocimiento y le permiten mejorar su comprensión de los mercados globales, el comercio en línea y nuestras herramientas comerciales. Nuestra lista completa de temas comerciales varía de básico a avanzado, y lo ayudará a elevar su negociación a un nivel superior.",
    "edu_Enhance": "Mejore su comprensión de los mercados globales y lleve su negociación al siguiente nivel aprovechando nuestros recursos educativos. FXView Education ofrece una extensa lista de temas que atienden a todos los niveles de comerciantes, desde principiantes hasta avanzados, y cubre tanto cómo funcionan los mercados como cómo usar nuestras herramientas comerciales para su ventaja.",
    "edu_tradeconfidence": "Aprenderá a comerciar con confianza centrándose en los aspectos técnicos y fundamentales de la negociación/inversión con nuestra ayuda y apoyo en todo.",
    "edu_basic": "Básico",
    "edu_advance": "Avanzado",
    "edu_general": "General",
    "edu_forex": "Atropellarse",
    "edu_commodities": "Productos básicos",
    "edu_indices": "Índices",
    "edu_stocks": "Cepo",
    "edu_thereIsNoRecord": "No se encontraron registros",
    "marin_source": "Fuente: Hoopsai",
    "marin_loadmore": "Carga más",
    "marin_loadwait": "Cargando por favor espere...",
    "news_marketnews": "Noticias de mercado",
    "news_fearurednews": "Noticias destacadas",
    "news_market": "Mercado",
    "news_nodata": "Sin datos",
    "news_latestnews": "Últimas noticias",
    "video_video": "Video",
    "video_tut": "Tutoriales",
    "video_intrestedforex": "¿Interesado en el comercio de divisas? Estás en el lugar correcto. FXVIEW ofrece una serie de tutoriales de video para ayudarlo a desarrollar sus habilidades y aprender a comerciar como los profesionales. Nuestras guías paso a paso incluyen instrucciones sobre el registro, la verificación de la cuenta, la terminología básica de Forex, la funcionalidad de la plataforma de negociación y mucho más.",
    "video_allvideo": "Todos los videos",
    "video_fxviewtut": "Tutoriales de FXView",
    "video_platTut": "Tutoriales de plataforma",
    "video_forexBasic": "Forex Conceptos",
    "video_whatisforex": "¿Cuál es el forex?",
    "web_webinars": "Seminarios web",
    "web_enhancetrad": "Mejore su comercio registrando nuestros seminarios web gratuitos y aprendiendo de expertos. Nuestros seminarios web están diseñados específicamente para aumentar el conocimiento de su mercado y perfeccionar sus habilidades comerciales. Los expertos revelan estrategias y conceptos comerciales clave, que pueden beneficiar a los principiantes y a los comerciantes experimentados.",
    "web_registeran": "Regístrese para un",
    "web_upcomingweb": "próximo seminario web",
    "web_register": "Registro",
    "web_timeleft": "Tiempo restante",
    "web_days": "DÍAS",
    "web_hours": "HORAS",
    "web_mins": "MINUTOS",
    "web_secs": "SECS",
    "web_webnar": "Seminario web",
    "web_library": "biblioteca",
    "web_higherpower": "Tendencias de tendencia-webinar",
    "web_aprtwenty": "(9 de agosto de 2021)",
    "web_findright": "Apoyo y resistencia-webinar",
    "web_aprsixteen": "(11 de agosto de 2021)",
    "web_weekahead": "Indicadores básicos-webinar",
    "web_aprtwelve": "(13 de agosto de 2021)",
    "web_introTrend": "Introducción a los indicadores de tendencias - Webinar",
    "web_apreighteen": "18 de marzo",
    "web_topicdiscuss": "TEMA DE DISCUSIÓN",
    "web_correlation": "FXVIEW-Using Correlación para mejorar su negociación",
    "web_datemay": "11 de mayo de 2021 12:00 - 12:40 PM GMT",
    "web_showlocal": "Muestra mi hora local",
    "web_joinfxview": "Únase a FXView Expert, ya que le da información sobre el uso de la correlación para mejorar sus habilidades comerciales.",
    "web_secureplace": "Asegure su lugar con el experto de la industria y aprenda lo que se necesita para ser un comerciante profesional de Forex",
    "web_topicsCovered": "Temas que se cubrirán durante el seminario web",
    "web_strongweak": "- Fuerte vs correlación débil",
    "web_corrmultiple": "- Correlación en múltiples plazos",
    "web_posneg": "- Comprender la correlación positiva y negativa",
    "ForexGlossarySpan": "Forex <span> glosario </span>",
    "ForexGlossaryGuide": "Forex Glosario de FXVIEW es una guía completa para ayudarlo a aprender la terminología básica de Forex y familiarizarse con la jerga de comerciante.",
    "AGGREGATE_DEMAND": "LA DEMANDA AGREGADA",
    "text": "Es una medición económica de la demanda total de todos los bienes y servicios terminados en una economía/sector. Indica cómo los niveles de precios actuales se relacionan con el PIB real de una nación (producto interno bruto).",
    "APPRECIATION": "APRECIACIÓN",
    "AppText": "Se refiere a un aumento en el valor de una moneda en relación con otra moneda en respuesta a la demanda del mercado.",
    "ARBITRAGE": "ARBITRAJE",
    "ArbText": "La compra de un activo financiero en un mercado y venta concurrente en otro mercado para beneficiarse de los diferenciales de precios se conoce como arbitraje.",
    "AROUND": "ALREDEDOR",
    "ArndText": "La jerga del concesionario se usa para citar cuándo la prima/descuento hacia adelante está cerca de la paridad. Por ejemplo, \"dos dos alrededor\" se traduciría en 2 puntos a cada lado del lugar actual.",
    "ASK_RATE": "Tarifa de solicitación",
    "Asktext": "La tarifa/precio a la que se ofrece un instrumento financiero a la venta.",
    "ASSET_ALLOCATION": "ASIGNACIÓN DE ACTIVOS",
    "AsstText": "Una estrategia de inversión que tiene como objetivo equilibrar el riesgo y la recompensa al asignar fondos a diferentes acciones, bonos, productos básicos, monedas y otras clases de activos según los objetivos de los inversores.",
    "Back_office": "Back office",
    "BalanceofTrade": "Balanza comercial",
    "BarCharts": "Gráfica de barras",
    "BaseCurrency": "Moneda base",
    "BearMarket": "Mercado de oso",
    "BidRate": "Tasa de oferta",
    "btext1": "Los departamentos verifican todo el acuerdo y los procesos relacionados",
    "btext2": "La diferencia de valor entre las exportaciones y las importaciones de un país.",
    "btext3": "Los gráficos de barras se utilizan en los mercados financieros para transmitir los movimientos de precios a una tabla fácil de legible. Básicamente son un gráfico OHLC utilizado para trazar precios. Hay una garrapata en el gráfico que proporciona al precio un período de tiempo dado en abierto, alto, bajo y cerca.",
    "btext4": "Una moneda que aparece en una cotización de pares de divisas. Siempre hay una moneda en el mercado de divisas que siempre se cotiza en relación con otra, ya que está comprando una mientras vende la otra. La moneda base aparecerá primero, seguida de la segunda moneda (cotización). Por ejemplo, si está mirando el par EUR/USD, aquí la moneda base es el euro y la moneda de cotización es el dólar estadounidense.",
    "btext5": "Un mercado caracterizado por la caída de los precios.",
    "btext6": "El precio máximo que un comprador está dispuesto a pagar.",
    "CABLE": "CABLE",
    "CABLEText": "Un apodo utilizado para el par GBP/USD. El término se originó debido al hecho de que la tasa se transmitió originalmente a través de un cable transatlántico que comenzó a mediados de 1800, cuando GBP era la moneda del comercio internacional.",
    "CANDLESTICK_CHART": "Gráfico de velas",
    "CANDLESTICK_CHARTText": "También se llama la tabla de velas japonesas, es un tipo de gráfico de barras utilizado esencialmente para describir los movimientos de precios de una seguridad, derivado o moneda. Cada \"candelabro\" generalmente muestra un día y representa la diferencia entre el precio de apertura y cierre. Si el precio de apertura es más alto que el precio de cierre, la vela/rectángulo está sombreada. Si el precio de cierre es más alto que el precio de apertura, esa área de la tabla no está sombreada.",
    "CENTRAL_BANK": "BANCO CENTRAL",
    "CENTRAL_BANKText": "Una organización gubernamental gubernamental o cuasi que supervisa las políticas monetarias de un país e imprime monedas. Por ejemplo, la Reserva del Banco Federal (EE. UU.), El Banco Central Europeo (Europa), Banco de la Reserva de Australia (Australia).",
    "CHARTISTs": "CHARTISTA",
    "CHARTISTsText": "Un individuo (también conocido como comerciante técnico) que utiliza cuadros y gráficos para interpretar datos históricos para encontrar tendencias y predecir los movimientos de precios futuros.",
    "CHOICE_MARKET": "Mercado de selección",
    "CHOICE_MARKETText": "También conocido como un mercado bloqueado, es un mercado sin diferenciales. Significa que una moneda se puede comprar al mismo precio que se puede vender en el mercado.",
    "CLEARING": "CLARO",
    "CLEARINGtext": "Proceso de conciliar o resolver compras y ventas de varios instrumentos financieros.",
    "CONTAGION": "CONTAGIO",
    "CONTAGIONText": "Tendencia de una crisis económica a propagarse de un mercado a otro.",
    "COLLATERAL": "COLATERAL",
    "COLLATERALText": "Algo dado por un prestatario para asegurar un préstamo o como garantía de rendimiento.",
    "COMMISSIONs": "COMISIÓN",
    "COMMISSIONText": "Una tarifa de transacción cobrada por el corredor de los comerciantes/inversores.",
    "CONFIRMATION": "CONFIRMACIÓN",
    "CONFIRMATIONText": "Documentos intercambiados por contrapartes a una transacción que establece los términos de dicha transacción.",
    "CONTRACTunit": "Contrato (unidad o lote)",
    "CONTRACTunitText": "La unidad estándar de comercio.",
    "COUNTERPARTY": "Contraparte",
    "COUNTERPARTYText": "Uno de los participantes, ya sea un banco o un cliente, con quien se realiza una transacción financiera.",
    "COUNTRY_RISK": "RIESGO PAÍS",
    "COUNTRY_RISKText": "Riesgos asociados con las transacciones transfronterizas como condiciones legales y políticas como la guerra.",
    "CROSS_RATES": "Tasas cruzadas",
    "CROSS_RATESText": "Tipos de cambio entre dos monedas que no involucran el dólar estadounidense. Se dice que una tasa cruzada no es estándar en el país donde se cotiza el par de divisas.",
    "CURRENCYe": "DIVISA",
    "CURRENCYText": "Un medio de intercambio en forma de papel, metal o digital emitido por un banco gubernamental/ central y utilizado como licitación legal.",
    "CURRENCY_RISK": "RIESGO DE CAMBIO",
    "CURRENCY_RISKText": "Riesgo de incurrir en pérdidas debido a un cambio adverso en los tipos de cambio.",
    "Day_trading": "Dia de cambio",
    "Day_tradingText": "Una estrategia comercial que involucra posiciones de apertura y cierre en el mismo día.",
    "Dealer": "Distribuidor",
    "DealerText": "Una persona que actúa como director o contraparte de una transacción. El director básicamente está en un lado con la esperanza de obtener buenas ganancias al cerrar la posición en un comercio posterior con otra parte.",
    "Deficit": "Déficit",
    "DeficitText": "Una cantidad por la cual el costo de las importaciones de un campo excede el costo de sus exportaciones o también se llama como un balance de comercio negativo.",
    "Delivery": "Entrega",
    "DeliveryText": "La liquidación de una transacción por entrega de fondos. O la fecha de vencimiento de un contrato, cuando la liquidación final de una transacción se realiza intercambiando las monedas.",
    "Depreciation": "Depreciación",
    "DepreciationText": "Disminuir en el valor de una moneda en relación con otra moneda debido a las condiciones del mercado u otros factores.",
    "Derivative": "Derivado",
    "DerivativeText": "Los derivados derivan su valor del precio de un activo subyacente y a menudo utilizados por los comerciantes como un instrumento para especular sobre los movimientos de precios futuros de un activo sin tener que comprar el activo en sí. La opción es el instrumento derivado más común.",
    "Devaluation": "Devaluación",
    "DevaluationText": "Una moneda se devalúa cuando su valor disminuye en relación con una o más otras monedas.",
    "ECONOMIC_INDICATOR": "INDICADOR ECONÓMICO",
    "ECONOMIC_INDICATORText": "Una medida estadística emitida por el gobierno o una institución no gubernamental que indica la condición económica de una economía como el PIB, la inversión extranjera, los déficits comerciales, las tasas de empleo, etc.",
    "ENDOFDAYORDER": "Orden de fin de día",
    "ENDOFDAYORDERText": "Una orden de comprar o vender a un precio específico que solo está abierto hasta el final del día de negociación, generalmente a las 5 p.m. de 5 pm/17: 00 New York.",
    "EUROs": "EURO",
    "EUROsText": "Moneda de la Unión Monetaria Europea (EMU).",
    "EUROPEANCENTRALBANK": "BANCO CENTRAL EUROPEO",
    "EUROPEANCENTRALBANKText": "Establecido en 1998, es el banco central para la Unión Monetaria Europea (EMU).",
    "FederalDepositInsurance": "Corporación Federal de Seguros de Depósitos (FDIC)",
    "FederalDepositInsuranceText": "Una agencia federal independiente que protege a los consumidores y al sistema financiero de EE. UU. La FDIC es la más conocida por el seguro de depósito, ya que ayudan a los clientes a evitar pérdidas en caso de fallas bancarias.",
    "FederalReserveSystem": "Sistema de reserva Federal",
    "FederalReserveSystemText": "La institución financiera más poderosa del mundo. El sistema de la Reserva Federal fue fundado por el Congreso de los Estados Unidos en 1913 con el objetivo de proporcionar un sistema monetario estable y comprende una agencia del gobierno central y 12 bancos regionales de la Reserva Federal.",
    "FixedExchangeRate": "Tipo de cambio fijo",
    "FixedExchangeRateText": "Un régimen de tipo de cambio donde el valor de una moneda es establecido por las autoridades monetarias contra el valor de una o más monedas.",
    "FloatingExchangeRate": "Tipo de cambio flotante",
    "FloatingExchangeRateText": "Un régimen de tipo de cambio donde el valor de la moneda es fijado por el mercado de divisas basado en la demanda y la oferta en relación con otras monedas.",
    "Flatsquare": "Plano/cuadrado",
    "FlatsquareText": "La jerga del concesionario solía describir una posición que se ha revertido por completo. Por ejemplo, compró $ 100,000 y luego vendió $ 100,000, por lo tanto, creó una posición plana.",
    "Foreign_Exchange": "Divisas",
    "Foreign_ExchangeText": "El cambio de divisas es el intercambio de una moneda para la otra. Es la red global en línea donde los comerciantes compran y venden monedas. No tiene ubicación física y funciona las 24 horas del día.",
    "Forward": "Adelante",
    "ForwardText": "La tasa previa especificada para bloquear un precio en un tiempo futuro específico, en función del diferencial de la tasa de interés entre las dos monedas involucradas.",
    "Forward_Contracts": "Contratos de reenvío",
    "Forward_ContractsText": "Un acuerdo entre las dos partes para comprar o vender un activo a una tasa especificada en una fecha de vencimiento previamente especificada. Ambas partes están obligadas a cumplir con su fin del acuerdo.",
    "ForwardRates": "Tarifas hacia adelante (swaps)",
    "ForwardRatesText": "La tasa a plazo es un precio en efectivo de 2 monedas diferencia de interés por un período fijo y se puede calcular fácilmente siempre que las tasas de interés fijas de cada moneda y la tasa spot actual se proporcione.",
    "Forward_Trading": "Comercio de avance",
    "Forward_TradingText": "El comercio hacia adelante está haciendo el comercio opuesto de un comercio spot en el momento dado. Los comerciantes a menudo cambian sus operaciones hacia adelante, desde una semana hasta meses. A pesar de que el contrato a plazo ocurre en una fecha futura, el puesto puede cerrarse en cualquier momento. Entonces, esa parte de cierre de la posición se cambia hacia la misma fecha de valor futuro.",
    "Forwardpoints": "Puntos de avance",
    "ForwardpointsText": "Simplemente las PIP que se agregan o se restan del tipo de cambio actual para calcular un precio a plazo.",
    "Fundamental_Analysis": "Análisis fundamental",
    "Fundamental_AnalysisText": "Método de análisis de los factores que pueden influir en el precio en el futuro. Esta forma de análisis se basa en eventos e influencias externas, así como en tendencias de la industria, a medida que los comerciantes técnicos obtienen información de cuadros y patrones.",
    "FuturesContract": "Contratos futuros",
    "FuturesContractText": "Un acuerdo legal entre dos partes para comerciar a un precio predeterminado, en una fecha predeterminada en el futuro. Los futuros se negocian a través de un intercambio y se pueden usar para obtener exposición a una amplia gama de activos.",
    "Gearing": "Engranaje",
    "GearingText": "Cuando un comerciante se cotiza con una deuda o margen parcial.",
    "GroupofFive": "Grupo de cinco (G5)",
    "GroupofFiveText": "Cinco naciones industriales líderes: Francia, Japón, Reino Unido, Alemania y EE. UU. Que se reúnen de vez en cuando con el motivo para discutir problemas económicos comunes.",
    "GroupofSeven": "Grupo de siete (7)",
    "GroupofSevenText": "El \"grupo de siete\" son 7 países principales no comunistas industrializados compuestos por Francia, Alemania, Reino Unido, Alemania y EE. UU. Más Canadá e Italia. Ahora son conocidos como el G8 desde la adición de Rusia.",
    "GroupofTen": "Grupo de diez (G10)",
    "GroupofTenText": "También llamado \"The Paris Club\" compuesto por Canadá, Bélgica, Francia, Alemania, Italia, Suecia, Japón, Reino Unido, EE. UU. Y los Países Bajos. Se formó en 1962 para poner los fondos a disposición del FMI y ayudar a los países miembros con dificultades de balance de pago.",
    "GoldilocksEconomy": "Economía de Oro de Oro",
    "GoldilocksEconomyText": "Un término que se utiliza para describir una economía que no está demasiado caliente o demasiado fría y mantiene un crecimiento moderado con una tasa nominal de inflación, que permite una política monetaria amigable para el mercado.",
    "GoodtilCancel": "Good ‘Til Canceled (GTC)",
    "GoodtilCancelText": "Un pedido que es válido hasta que se cancela o se completa, independientemente de la cantidad de tiempo cuando se realizó el pedido.",
    "HEDGING": "Cobertura",
    "HEDGINGText": "Una estrategia de gestión de riesgos por la cual los inversores \"se cubren\" para protegerse de los movimientos adversos de los precios tomando dos posiciones opuestas y, por lo tanto, reducen el riesgo. En el contexto de las transacciones monetarias, protegería a uno contra las fluctuaciones en el tipo de cambio de Forex.",
    "INFLATION": "INFLACIÓN",
    "INFLATIONText": "Un aumento continuo en el nivel general de precios de los bienes de consumo, que erosiona el poder adquisitivo.",
    "INITIALMARGIN": "MARGEN INICIAL",
    "INITIALMARGINText": "El depósito inicial de la garantía requerida para ingresar a un puesto como garantía sobre el rendimiento futuro.",
    "INTERBANKRATES": "Tasas intersil",
    "INTERBANKRATESText": "Los tipos de cambio en los que los grandes bancos internacionales citan a otros grandes bancos internacionales.",
    "LEADINGINDICATORS": "Indicadores principales",
    "LEADINGINDICATORSText": "Variables económicas consideradas para predecir la actividad económica futura.",
    "LEVERAGEs": "APROVECHAR",
    "LEVERAGEsText": "Los corredores ofrecen el apalancamiento para maximizar el poder de compra del operador. Se puede describir como \"capital prestado\" desde el punto de vista de los comerciantes y aumenta sus rendimientos potenciales, ya que puede negociar volúmenes mucho más grandes con estos fondos que su capital limitado. Se expresa en proporciones como 1: 100, 1: 300 y así sucesivamente. Entonces, con un apalancamiento de 1: 100, el poder de compra de un comerciante se magnifica 100 veces. <strong> descargo de responsabilidad: </strong> apalancamiento amplifica posibles rendimientos y pérdidas.",
    "LIBOR": "Libor",
    "LIBORText": "El London Interbank ofreció tarifa. Es la tasa de interés de referencia a la que los principales bancos globales se prestan entre sí.",
    "LIMITORDER": "Orden de límite",
    "LIMITORDERText": "Una orden para ejecutar una operación a un precio específico o mejor. Por ejemplo, si el precio actual de EUR/USD es 1.08502/1.08522, entonces una orden límite para comprar EUR estaría a un precio por debajo del precio del mercado, 1.0820.",
    "LINECHARTS": "Gráficos de línea",
    "LINECHARTSText": "Una tabla de precios que conecta los precios individuales (todos los precios de cierre) por un período de tiempo seleccionado.",
    "LIQUIDITYs": "LIQUIDEZ",
    "LIQUIDITYsText": "La capacidad de un par de divisas para ser comprado y vendido en el mercado sin causar un cambio significativo en su tipo de cambio.",
    "LIQUIDATION": "LIQUIDACIÓN",
    "LIQUIDATIONText": "Cierre de una posición existente mediante la ejecución de una transacción compensatoria.",
    "LONGPOSITION": "POSICIÓN LARGA",
    "LONGPOSITIONText": "Se dice que una posición es \"larga\" si se aprecia en valor cuando aumentan los precios del mercado. Cuando uno compra un par de divisas, su posición es larga en ese par.",
    "Margins": "Margen",
    "MarginText": "El margen es la cantidad de dinero que se requiere para mantener abierta una posición de margen. Es la diferencia entre el valor total de su posición y los fondos que se le prestan a usted por un proveedor de corredores/apalancamiento.",
    "MarginDeposit": "Depósito de margen",
    "MarginDepositText": "Un depósito de margen es la cantidad inicial de dinero que un comerciante requiere para reducir para abrir una posición de negociación apalancada. También se puede conocer como margen inicial, depósito o simplemente depósito.",
    "MarginCall": "Llamada de margen",
    "MarginCallText": "Una llamada de margen puede describirse como una alerta/solicitud/llamada de su corredor para notificarle que su margen de mantenimiento ha caído por debajo del mínimo y su posición corre el riesgo de ser liquidada. Entonces, en tal caso, un corredor le pide a un cliente que recargue su cuenta para mantener abierta la posición existente.",
    "MarketMaker": "Creador de mercado",
    "MarketMakerText": "Un concesionario que mantiene una oferta firme y solicita el precio y está listo para hacer un mercado de dos lados para cualquier instrumento financiero.",
    "MarketRisk": "Riesgo de mercado",
    "MarketRiskText": "Exposición a cambios en los precios del mercado.",
    "Marktomarket": "Marca al mercado",
    "MarktomarketText": "Ajustar/evaluar todas las posiciones abiertas de acuerdo con los precios actuales del mercado.",
    "Maturity": "Madurez",
    "MaturityText": "La fecha de liquidación o vencimiento de un instrumento financiero.",
    "NarrowMarket": "Mercado estrecho",
    "NarrowMarketText": "Exchange Market también caracterizado por el mercado delgado donde hay un bajo número de compradores y vendedores y los precios tienden a ser volátiles.",
    "Offer_s": "Oferta",
    "OfferText": "Lo mismo que el precio de Ask, el precio al que un distribuidor está dispuesto a vender.",
    "Offsettingtransaction": "Transacción de compensación",
    "OffsettingtransactionText": "La compensación puede significar cerrar una posición para cancelar o compensar parte o el total de riesgos de mercado de una posición abierta.",
    "OneCancelsOrder": "Uno cancela el otro orden (OCO)",
    "OneCancelsOrderText": "Cuando realice una orden de parada y una orden de límite y si se ejecuta cualquiera de los que se ejecute, el otro pedido se cancelará automáticamente.",
    "Openorder": "Pedido abierto",
    "OpenorderText": "Una orden que no tiene una fecha de vencimiento específica y se ejecuta cuando se alcanza un precio de mercado específico. Generalmente se asocian con las órdenes GTC.",
    "Open_position": "Posición abierta",
    "OpenPositionText": "Una posición que aún está activa y aún no cerrada o invertida.",
    "OvertheCounter": "Sin receta (OTC)",
    "OvertheCounterText": "El comercio de OTC es para los valores de aquellas compañías que no figuran en ningún intercambio central, por lo que la compra y venta de dichos valores se realiza sin receta, es decir, a través de corredores y distribuidores privados, que negocian directamente con compradores y vendedores.",
    "Overnight": "Durante la noche",
    "OvernightText": "Un comercio/posición que permanece abierto hasta el siguiente día hábil.",
    "Pip_s": "Pips",
    "PipText": "La menor cantidad de cambio en un precio de Forex cotizado. La mayoría de las monedas principales definen un PIP como el cuarto lugar decimal, por lo que un cambio de PIP es equivalente a 0.0001, excepto el yen japonés donde un PIP es el segundo dígito después del punto decimal.",
    "PoliticalRisk": "Riesgo político",
    "PoliticalRiskText": "Debido a los cambios o inestabilidad en la política gubernamental, el efecto adverso en las posiciones/rendimientos de un inversor.",
    "PointFigureCharts": "Gráficos de puntos y figuras",
    "PointFigureChartsText": "La tabla de puntos y cifras no tiene en cuenta el tiempo de vista y se centra completamente en los movimientos y tendencias de precios en el activo.",
    "Position_s": "Posición",
    "PositionText": "La posición es el término financiero para un comercio que actualmente es activo y capaz de incurrir en pérdidas/ganancia llamada posición abierta o un comercio que recientemente se ha cerrado conocido como posición cerrada.",
    "Premium": "De primera calidad",
    "PremiumText": " La cantidad por la cual el precio futuro o a continuación excede el precio spot.",
    "PriceTransparency": "Anticetransparencia",
    "PriceTransparencyText": " Elucidar cotizaciones a las que cada participante del mercado puede tener el mismo acceso",
    "Quote_s": "Cita",
    "QuoteText": "Un precio al que se negoció por última vez o se puede comprar o vender un activo por última vez y usarse solo para información adicional.",
    "RATE_s": "TASA",
    "RATEText": "El precio de una moneda en términos de la otra, cuyos valores cambian en relación con cada uno con el tiempo.",
    "RESISTANCE_s": "RESISTENCIA",
    "RESISTANCEText": "Un término de análisis técnico de uso común que indica un nivel de precio específico en el que una moneda tendrá la incapacidad de cruzar. Tal precio actúa como un techo.",
    "REVALUATION": "REVALORIZACIÓN",
    "REVALUATIONText": "Lo contrario a la devaluación, la revaluación es un ajuste al alza al tipo de cambio oficial de un país como resultado de la intervención del banco central.",
    "REVALUATIONRATES": "Tasas de revaluación",
    "REVALUATIONRATESText": "Estas son las tasas de mercado utilizadas como valor base por parte de los operadores para evaluar si las ganancias/pérdidas se han obtenido durante el día o en general. Por lo general, la tasa de revaluación es la tasa de cierre para el día de negociación anterior.",
    "RISK_s": "RIESGO",
    "RISKText": "Potencial de un resultado negativo, como bajo rendimiento, no alcanzar los objetivos de comercio/inversión o perder dinero o cambios adversos.",
    "RISKCAPITAL": "CAPITAL DE RIESGO",
    "RISKCAPITALText": "La cantidad de dinero que un individuo puede invertir, cuya pérdida no dará como resultado un cambio sustancial en su estilo de vida.",
    "RISK_MANAGEMENT": "GESTIÓN DE RIESGOS",
    "RISKMANAGEMENTText": "Todas las técnicas y estrategias utilizadas para mitigar y/o controlar los riesgos inherentes en el comercio y la inversión, como el uso de pérdidas de parada, cobertura, diversificación, etc.",
    "ROLLOVER": "DESE LA VUELTA",
    "ROLLOVERText": "Es el cierre simultáneo de una posición abierta para la fecha de valor de hoy y la apertura de la misma posición para la fecha de valor del día siguiente a un precio que refleja los diferenciales de tasas de interés entre dos monedas.",
    "ROLLOVERRATE": "Tasa de volar",
    "ROLLOVERRATEText": "Los intereses pagados o ganados durante la noche por las tenencias de la posición/s, dependiendo del margen y la posición establecidos en el mercado.",
    "SETTLEMENT": "ASENTAMIENTO",
    "SETTLEMENTText": "La transferencia de la propiedad de un instrumento financiero a un comprador. La liquidación de las operaciones de divisas puede o no involucrar el cambio físico real de una moneda a otra.",
    "SHORTPOSITION": "POSICIÓN CORTA",
    "SHORTPOSITIONText": "Se dice que una posición es corta cuando un comerciante vende una seguridad primero con la intención de recomprarlo más tarde cuando cae el precio. Tal posición se toma cuando él cree que es probable que los precios caigan en el futuro cercano.",
    "SLIPPAGE": "Deslizamiento",
    "SLIPPAGEText": "El deslizamiento ocurre cuando la propagación de oferta/previo se extiende los cambios entre el momento en que se solicita un pedido hasta el momento en que se ejecuta el pedido. Esto generalmente ocurre durante los períodos de alta volatilidad y ocurre en todos los mercados, como la equidad, los bonos, las monedas y los futuros.",
    "SPOTNEXT": "Spot/Siguiente",
    "SPOTNEXTText": "También conocido como \"Siguiente día hábil, denota la entrega de una moneda comprada un día después de la fecha de spot\". Son intercambios a corto plazo donde una moneda se implementa un día más, es decir, después del lugar.",
    "SPOTPRICE": "PRECIO DE CONTADO",
    "SPOTPRICEText": "El precio actual de mercado de un instrumento financiero.",
    "SPOTRATE": "Punto (tasa)",
    "SPOTRATEText": "El tipo de cambio actual al que se puede comprar o vender una moneda. Es la tasa cotizada en el mercado minorista sin ajuste por el diferencial de tasas de interés.",
    "SPOTTRADE": "Comercio de manchas",
    "SPOTTRADEText": "Se refiere a la compra y venta de un producto financiero para la entrega instantánea en una fecha spot especificada. También se conoce como una transacción puntual y típicamente se establece electrónicamente.",
    "Spread_s": "Desparramar",
    "SpreadText": "Un diferencial en el comercio significa el rango/diferencia entre la oferta y el precio de solicitud cotizado para un par de divisas.",
    "Sterling": "Libra esterlina",
    "SterlingText": "Un término para la libra británica.",
    "StopLossOrder": "Detener la orden de pérdida de pérdida",
    "StopLossOrderText": "Un tipo de pedido para vender una moneda cuando el precio alcanza o cae por debajo del precio especificado. Esto se usa para limitar la pérdida, generalmente cuando el comerciante no puede monitorear activamente el precio.",
    "StochasticOscillator": "Oscilador estocástico",
    "StochasticOscillatorText": "El término estocástico se refiere al punto de un precio actual en relación con su rango de precios durante un período de tiempo. El oscilador estocástico es un indicador de análisis técnico popular que establece que durante un mercado comercial ascendente, los precios tienden a cerrar cerca de su alto y viceversa.",
    "SupportLevels": "Niveles de soporte",
    "SupportLevelsTexts": " Este término indica un nivel de precio específico en el que una moneda tendrá la incapacidad de cruzar a continuación. El apoyo ocurre cuando la caída de los precios se detiene, cambia de dirección y comienza a aumentar. El nivel de soporte a menudo se ve como un \"piso\" que respalda o mantiene los precios.",
    "Swap_s": "Intercambio",
    "SwapText": "SWAP es un contrato derivado a través del cual dos partes intercambian flujos o pasivos de efectivo derivados de dos instrumentos financieros diferentes.",
    "Swift": "Rápido",
    "SwiftText": "Sociedad de telecomunicaciones financieras interbancarias mundiales. Proporciona una red informática dedicada que permite a las instituciones financieras de todo el mundo apoyar los mensajes de transferencia de fondos en un entorno seguro, estandarizado y confiable.",
    "TECHNICALANALYSIS": "ANÁLISIS TÉCNICO",
    "TECHNICALANALYSISText": "Implica el uso de varios indicadores técnicos y análisis de la acción del mercado a través del estudio de cuadros, volumen, tendencias, patrones, promedios móviles y varios otros indicadores técnicos con el propósito de pronosticar los precios.",
    "TICK_s": "GARRAPATA",
    "TICKText": "Una garrapata representa cualquier cotización de precios más próxima, arriba o hacia abajo.",
    "TICKER": "CORAZÓN",
    "TICKERText": "Muestra el historial actual o reciente de una moneda en el formato de una tabla o un gráfico.",
    "TOMORROWNEXT": "Mañana siguiente (Tom/Next)",
    "TOMORROWNEXTText": "Es la compra y venta simultánea de una moneda para la entrega al día siguiente.",
    "TRADING_s": "COMERCIO",
    "TRADINGText": "El acto de comprar, vender, intercambiar acciones, bonos o monedas, etc.",
    "TRANSACTIONCOST": "COSTO DE LA TRANSACCIÓN",
    "TRANSACTIONCOSTText": "Costo de comprar y vender un instrumento financiero.",
    "TRANSACTIONDATE": "FECHA DE TRANSACCIÓN",
    "TRANSACTIONDATEText": "La fecha en que ocurre un comercio.",
    "TREND_s": "TENDENCIA",
    "TRENDText": "Una tendencia es simplemente la tendencia de un precio a moverse en una determinada dirección, arriba/hacia abajo/inversa/lateral. Por lo general, se descomponen a tres categorías: tendencias principales, intermedias y a corto plazo.",
    "TRENDLINE": "Línea de tendencia",
    "TRENDLINEText": " Este es un indicador técnico muy utilizado para descubrir tendencias. Una línea de tendencia conecta dos o más mínimos o más máximos con las líneas proyectadas en el futuro. Se calcula utilizando el \"método de mínimos cuadrados\" y también se llama regresión lineal.",
    "TURNOVER": "ROTACIÓN",
    "TURNOVERText": "Es el valor monetario total de todas las transacciones ejecutadas en un período de tiempo determinado.",
    "TWOWAYPRICE": "Precio de dos vías",
    "TWOWAYPRICEText": "Una cotización de dos vías indica tanto el precio de la oferta actual como el precio actual de Ask de una seguridad en un día de negociación.",
    "UPTICK": "Repugnante",
    "UPTICKText": "Se produce un aumento cuando el precio de una seguridad aumenta en relación con la última marca. Es una nueva cotización de precios a un precio más alto que la cita anterior.",
    "UPTICKRULE": "Regla del aumento",
    "UPTICKRULEText": "Una restricción comercial en los Estados Unidos que establece que la venta corta solo está permitida en un aumento. Según la regla, no se puede vender una seguridad a menos que la última operación antes de la venta corta fuera a un precio inferior al precio al que se ejecuta la venta corta.",
    "USPRIMERATE": "Tasa prefantera de EE. UU.",
    "USPRIMERATEText": "La tasa de interés a la que los bancos estadounidenses prestarán a sus principales clientes corporativos.",
    "VALUEDATE": "Fecha de valor",
    "VALUEDATEText": "La fecha en que las contrapartes acuerdan resolver sus respectivas obligaciones. Para las transacciones de moneda spot, la fecha de valor suele ser dos días hábiles hacia adelante. También conocido como fecha de vencimiento, es la fecha en que se resuelve la transacción.",
    "VARIATIONMARGIN": "Margen de variación",
    "VARIATIONMARGINText": "Los comerciantes de fondos deben mantener en sus cuentas para mantener un comercio apalancado abierto. El término generalmente se refiere a fondos adicionales que deben depositarse como resultado de movimientos de precios desfavorables.",
    "VOLATILITYVOL": "Volatilidad (vol)",
    "VOLATILITYVOLText": "Caracterizado por movimientos de precios rápidos y aleatorios, es un término utilizado para referirse a mercados activos que a menudo presentan oportunidades comerciales.",
    "VOLUME_s": "VOLUMEN",
    "VOLUMEText": "Número total de contratos negociados durante un período específico.",
    "WeakDollarStrongDollar": "Dólar débil/ dólar fuerte",
    "WeakDollarStrongDollarText": "El término dólar débil y fuerte se usa en el mercado de divisas para describir el valor relativo y la fortaleza del dólar estadounidense contra otras monedas. Se dice que el dólar es débil cuando se requieren más dólares para comprar una unidad de otra moneda y fuerte cuando se requieren pocos dólares para comprar una unidad de otra moneda.",
    "Whipsaw": "Lágrima",
    "WhipsawText": "Una condición de volatilidad extrema cuando el rápido crecimiento de un precio es seguido por una caída drástica (o viceversa).",
    "Yard": "Patio",
    "YardText": "Término de divisas para mil millones de unidades",
    "YIELD": "PRODUCIR",
    "YIELDText": "Los ingresos obtenidos de una inversión.",
    "steps_heading1": "Informacion personal",
    "steps_heading2": "Declaración",
    "steps_heading3": "Subir documentos personales",
    "step1_personalinfo": "Informacion personal",
    "step1_fname": "Nombre de pila",
    "step1_age_error": "Lo siento, solo aceptamos clientes mayores de 18 años",
    "step1_lname": "Apellido",
    "step1_dob": "DoB",
    "step1_dobrequired": "Se requiere el DOB",
    "step1_below18": "Tu edad es inferior a 18",
    "step1_addinfo": "Datos del Domicilio",
    "step1_city": "Ciudad",
    "step1_postalcode": "Código Postal",
    "step1_countryRes": "País de residencia",
    "step1_otherinfo": "Otra información",
    "step1_addInfo": "información adicional",
    "step1_phno": "Número de teléfono",
    "step1_phnoRequired": "Se requiere el número de teléfono",
    "step1_correctno": "Ingrese el número de teléfono correcto",
    "step1_prefcurrency": "Seleccione la moneda de billetera preferida",
    "step1_pep": "¿Eres una persona políticamente expuesta (PEP)?",
    "step1_usPerson": "¿Eres una persona estadounidense?",
    "step1_Next": "Próximo",
    "step1_firstmember": "Información del primer miembro",
    "step1_member1dob": "Se requiere un miembro 1 fecha de nacimiento",
    "step1_member1age": "Miembro 1 Edad está a continuación 18",
    "step1_secondmember": "Información de segundo miembro",
    "step1_menber2dobreq": "Se requiere el miembro 2 fecha de nacimiento",
    "step1_member2age": "Miembro 2 La edad es un grito 18",
    "step1_adressinfo": "Datos del Domicilio",
    "step1_companyinfo": "Información de la empresa",
    "step1_companyname": "nombre de empresa",
    "step1_incopDate": "Fecha de incorporación",
    "step1_incodateReq": "Se requiere la fecha de incorporación",
    "step1_futuredate": "Fecha futura no permitir",
    "step1_authorperson": "Información de persona autorizada",
    "step1_companyAdrsinfo": "Información de la dirección de la empresa",
    "step1_regAddone": "Dirección de la empresa registrada Línea 1",
    "step1_regAddtwo": "Línea de dirección de la empresa registrada 2",
    "step1_country": "País",
    "step1_minimumph": "El número de teléfono incluye al menos 8 caracteres",
    "step1_maxphone": "El número de teléfono puede no ser mayor de 15 caracteres",
    "step1_stepMsz2": "Un PEP es una persona natural a la que se le ha confiado las siguientes funciones públicas prominentes en cualquier país, así como a sus familiares y personas inmediatas que se sabe que son asociados cercanos de una persona de este tipo: <ul> <li> Jefes de Estado , Jefes de gobierno, ministros y ministros adjuntos o asistentes, </li> <li> miembros de parlamentos o de organismos legislativos similares, </li> <li> Miembros de los órganos gobernantes de los partidos políticos, </li> <li> Miembros de los Tribunales Supremos, de los tribunales constitucionales o de otros organismos judiciales de alto nivel cuyas decisiones no están sujetas a una apelación adicional, excepto en circunstancias excepcionales, </li> <li> miembros de los tribunales de auditores o de las juntas de los bancos centrales, </li> <li> Embajadores, cargés de asuntos y oficiales de alto rango en las Fuerzas Armadas, </li> <li> Miembros de organismos administrativos, gerenciales o supervisorios de empresas gubernamentales o empresas de propiedad establecida, </li> <li> Directores, directores adjuntos y miembros de la Junta Directiva o personas que ocupan un puesto equivalente en una organización internacional, </li> <li> Alcaldes </li> </ul>",
    "step1_stepMsz3": "La definición de una persona estadounidense (\"persona de los Estados Unidos\") incluye: <ul> <li> Un ciudadano o residente estadounidense (incluida la doble ciudadanía), </li> <li> un alienígena estadounidense (residente a efectos fiscales) <// li> <li> ¿Una persona nacida en los Estados Unidos? </li> <li> Una persona con una dirección de correo o residencia de correo actual de los EE. UU. (incluida una caja de correos de EE. UU. O la dirección de los EE. UU.) </li> <li> Una persona con un número de teléfono actual de EE. UU. </li> <li> Una persona con instrucciones permanentes para transferir fondos a una cuenta mantenida en los Estados Unidos? </li> <li> Una persona con poder notarial actual y efectivo o autoridad firmante otorgada a una persona con dirección de EE. UU. > </ul>",
    "step2_financialDetails": "Detalles financieros",
    "step2_txt1": "Si se emplea, especifique",
    "step2_txt2": "Ingresos anuales estimados (USD)",
    "step2_txt3": "Patrimonio neto estimado (USD)",
    "step2_txt4": "Fuente de fondos",
    "step2_txt5": "Guardar Continuar",
    "step2_txt6": "Empleo",
    "step2_txt7": "Herencia",
    "step2_txt8": "Inversión",
    "step2_txt9": "Bienes raíces",
    "step2_txt10": "Ahorros",
    "step2_txt11": "Otro",
    "step3_Questions": "Preguntas",
    "step3_txt1": "Vamos a probar su experiencia comercial",
    "step3_txt2": "Como entidad regulada, debemos evaluar si tiene una comprensión adecuada para el comercio de productos apalancados. Complete detenidamente su prueba de adecuación, ya que sus respuestas se utilizarán para determinar si puede abrir una cuenta comercial en vivo con nosotros.",
    "step3_txt3": "Prueba de inicio",
    "step4_readaccept": "He leído, entendido y aceptado el",
    "step4_ClientAgreement": "Acuerdo del cliente",
    "step4_privacyplicy": "política de privacidad",
    "step4_and": "y",
    "step4_riskDisclosr": "Documentos de divulgación de riesgos",
    "step4_termsAgreeRqd": "Por favor acepte estos Términos",
    "step4_policytwo": "Estoy de acuerdo en que mis datos personales se procesen y almacenen según la Política de privacidad, y que FXView se ponga en contacto conmigo con respecto a la información importante para mi cuenta.",
    "step4_AfterCalling": "Nota: después de hacer clic en",
    "step4_saveContinue": "Guardar Continuar",
    "step4_allInfoCorrect": "No podrá cambiar ninguna información de paso anterior. ¡Asegúrese de que toda la información sea correcta!",
    "step5_browsersupport": "Tal vez el navegador se enfrente a un problema técnico con la cámara web",
    "step5_cameradenied": "Permiso de la cámara denegado",
    "step5_scanqrcode": "Escanear el código QR en su lugar",
    "step5_scanqrmobile": "Escanee este código QR utilizando su cámara móvil o aplicación de código QR",
    "step5_keepageopen": "Mantenga esta página abierta mientras usa su móvil",
    "step5_continueBrowser": "Continuar con el navegador",
    "step5_docSubsuccess": "Sus documentos han sido enviados con éxito. Sea paciente mientras revisamos sus documentos y puede tomar hasta 24 horas o más durante la hora pico.",
    "step5_reviewstatus": "Haga clic aquí para revisar el estado de su boleto",
    "step5_identifyDoc": "DOCUMENTOS IDÉNTICOS",
    "step5_proofresidence": "Prueba de documentos de residencia",
    "step5_uploadphototext": "Sube una foto de tu documento de identidad. Asegúrese de que los detalles sobre la identificación coincidan con la información que ingresó en el formulario de información personal.",
    "step5_uploadproof": "Cargue una prueba de su dirección de residencia (a su nombre y no más de 6 meses). Tenga en cuenta que no aceptamos capturas de pantalla.",
    "step5_takephoto": "Tome una foto de su licencia de conducir y cárguela aquí",
    "step5_takegovernid": "Tome una foto de su identificación emitida por su gobierno y suba aquí",
    "step5_goodQuality": "Buena calidad:",
    "step5_brightclear": "Brillante y claro",
    "step5_note": "Nota:",
    "step5_allcorner": "Todas las esquinas del documento a ser visibles y el documento deben ser válidos (no caducados)",
    "step5_allcorner1": " Debe mostrar su nombre completo, dirección de residencia, institución emisora ​​y fecha de emisión. Todas las esquinas del documento serán claramente visibles.",
    "step5_uploadfrontside": "Sube la parte frontal de tu documento",
    "step5_maximumfilesize": "El tamaño máximo de archivos se puede cargar hasta",
    "step5_maxfilesize": "El tamaño máximo del archivo aceptado es hasta",
    "step5_uploadbackside": "Sube la parte posterior de tu documento",
    "step5_upload": "Subir",
    "step5_idenfNumber": "Mencione su número de identificación ubicado en su Identity Docuemtn.",
    "step5_uploadpassport": "Tome una foto de su pasaporte y suba aquí",
    "step5_photolicense": "Tome una foto de su licencia de conducir y cárguela aquí",
    "step5_photogovernmentID": "Tome una foto de su identificación emitida por su gobierno y suba aquí",
    "step5_proofsixold": "Tome una foto de su prueba o residencia (no mayor de 6 meses):",
    "step5_bankstatement": "Declaración bancaria, factura de servicios públicos (agua, electricidad, internet en el hogar o fijación fija), documento fiscal, acuerdo de alquiler (si se emite en los últimos 6 meses)",
    "step5_uploadyourDoc": "Sube tu documento",
    "step5_idnorequired": "Se requiere número de identificación.",
    "step5_filesizemax": "El tamaño de los archivos puede ser máximo",
    "step5_filesallowed": "¡Solo se permiten archivos JPG, JPEG, PNG, PDF!",
    "step5_uploadbothside": "Por favor cargue ambos lados de su documento",
    "step5_verifydoc": "Sube tu documento para verificar tu información",
    "step5_continuemobile": "Continuar con Mobile",
    "step5_recentphoto": "Por favor, suba su foto reciente",
    "step5_photoverif": "Verificación de fotos",
    "step5_legitimacy": "Se requiere que todos los usuarios carguen una foto de verificación. Esto es solo parte de las numerosas técnicas y sistemas que empleamos para garantizar la legitimidad de nuestros usuarios.",
    "step5_back": "atrás",
    "step5_start": "Usar webcam",
    "step5_TakeSelfie": "Toma una selfie",
    "step5_webcamdont": "Continuar con Mobile",
    "step5_captureimage": "Capturar imagen",
    "step5_cancel": "Cancelar",
    "step5_filemax": "El tamaño de los archivos puede ser máximo de",
    "step5_choosefileupload": "Elige un archivo para subir",
    "step5_allowmaxsize": "El tamaño máximo del archivo que permitimos es de",
    "step5_useWebcam": "Usar cámara web",
    "soclTrade_zullutrade": "Comercio zulú",
    "soclTrade_mql": "MQL5",
    "zulu_trade": "Zulutrada",
    "zulu_zulitradeinfo": "Zulu Trade es una plataforma de comercio social donde puede seguir a los comerciantes en todo el mundo y copiar operaciones mientras aprende de las estrategias que usan. Según la información completa disponible para sus estilos comerciales y su rendimiento, puede hacer fácilmente los comerciantes de su elección y una vez que los siga, sus operaciones se copiarán automáticamente en su cuenta.",
    "zulu_createAccount": "Crear cuenta de Zulu",
    "zulu_setupzulutrade": "Cómo configurar la cuenta Zulutrade",
    "zulu_registeropen": "Regístrese y abra una cuenta FXView Zulutrade.",
    "zulu_findaccount": "Finice la cuenta con un mínimo de $ 100 para recibir credenciales de inicio de sesión del Zulutrade.",
    "zulu_logintozulu": "Inicie sesión en el sitio web de Zulu Trade y comience a seguir cualquier comerciante de su elección.",
    "mampam_heading": "Mam/Pamm",
    "mampam_programenable": "El programa FXVIEW MAM/PAMM permite a los comerciantes experimentados administrar múltiples cuentas subconsador bajo una sola cuenta maestra, de manera profesional.",
    "mampam_knowmore": "Saber más",
    "mampam_becameinvestor": "Cómo convertirse en inversor:",
    "mampam_clicktobecame": "Haga clic en \"Conviértase en un inversor\"\n",
    "mampam_uniquepamid": "Ingrese la ID de PAMM única de su gerente para ver su perfil.",
    "mampam_createinverstor": "Cree su cuenta de inversionista y conéctese con la cuenta PAMM",
    "mampam_monitoracc": "Monitoree su cuenta a través del tablero de Pamm Investor",
    "mampam_connectmanager": "Conéctese a un gerente",
    "mampam_becomemanager": "Cómo convertirse en gerente:",
    "mampam_clickbecomemanager": "Haga clic en \"Conviértase en gerente\"",
    "mampam_meetconditions": "Cumplir con las condiciones requeridas para recibir su ID de PAMM única",
    "mampam_manageaccount": "Administre su cuenta a través de un Portal exclusivo de PAMM",
    "mampam_becomeManager": "Convertirse en gerente",

    //=========mam-pamm-account
	"mampamm_account_tab": 'Sub Account',
	"mampamm_account_account_type": 'Sub Account',
	"mampamm_account_heading": 'Account IB MAMM',
	"mampamm_account_description": 'The fxview MAM/PAMM program enables experienced traders to manage multiple sub accounts under a single master account, in a professional manner.',
	"mampamm_account_regsiter_heading": 'Steps to register IB MAMM Account',
	"mampamm_account_clicktobecame": 'Click on "Become an Investor"',
	"mampamm_account_uniquepamid": 'Enter your manager’s unique PAMM ID to view his profile.',
	"mampamm_account_createinverstor": 'Create your investor account and connect with the PAMM account',
	"mampamm_account_monitoracc": 'Monitor your account through PAMM investor’s dashboard',
	"mampamm_account_disclaimer": 'Disclaimer',
	"mampamm_account_username": 'Name',
	"mampamm_account_usernameRequired": 'The name is required',
	"mampamm_account_signature": 'Signature',
	"mampamm_account_signatureRequired": 'The signature is required',
	"mampamm_account_signatureMatchError": "Signature doesn't match with username",
	"mampamm_account_termscondition": 'I accept all the Terms and Conditions.',
	"mampamm_account_termsconditionRequired": 'Please agree terms and conditions in order to proceed',
	"mampamm_account_Proceed": 'Proceed to Create IB MAMM Account',
	"mampamm_account_Cancel": 'Cancel',
	"mampamm_account_Create": 'Create IB MAMM Account',
	"mampamm_account_List_Header": 'MY IB MAMM Account',
	"mampamm_account_Open_Ib_Mam_Pamm": 'Open IB MAMM Trading Account',
	"mampamm_account_Created_Successfully": 'Your account IB MAMM has been successfully created. Your credentials are:',
	"mampamm_account_Disclaimer_Approved_Successfully": 'Disclaimer approved successfully',
	"mampamm_account_No_Pdf_Found": 'No pdf found',

    
    "mql_heading": "MQL5",
    "mql_text": "MQL5 es una de las comunidades más grandes de comercio de copias del mundo, que conecta a los comerciantes novatos con los experimentados. Los usuarios pueden elegir entre miles de señales verificadas gratuitas y de tarifa para mejorar su rendimiento comercial",
    "mql_createliveAcc": "Crear cuenta en vivo",
    "mql_stepsRegister": "Pasos para registrar MQL5",
    "mql_stepone": "Registre una cuenta MQL5 en sus sitios web",
    "mql_stepTwo": "Abra la plataforma Metatrader y vaya a las herramientas >> Opciones y haga clic en la pestaña Comunidad. Inicie sesión en la cuenta MQL5 y haga clic en Aceptar.",
    "mql_stepThree": "Vaya a la pestaña de señales en la ventana Terminal y seleccione la señal que desea seguir.",
    "unaut_under": "Bajo",
    "unaut_Verification": "Verificación",
    "unaut_pendingVerificationMsz1": "Su solicitud está en revisión por nuestro departamento de cumplimiento. Se puede ver 3-4 días hábiles para que se verifiquen sus documentos. Recibirá un correo electrónico una vez que se verifiquen sus documentos",
    "createzullu_Your": "Su",
    "createzullu_successcreate": "La cuenta Zulu se ha creado con éxito. Tus credenciales son:",
    "createzullu_accountBaseCurrency": "Moneda base de cuentas",
    "createzullu_tradenow": "Negocia ahora",
    "fund_now": "Fondo ahora",
    "createzullu_forWeb": "Para la web",
    "createzullu_open": "Abierto",
    "createzullu_tradingAcc": "Cuenta de operaciones",
    "createzullu_classic": "Clásico",
    "createzullu_profitsharing": "Participación en las ganancias",
    "createzullu_USD": "Dólar estadounidense",
    "createzullu_EUR": "EUR",
    "createzullu_GBP": "GBP",
    "createzullu_AUD": "Audio",
    "createzullu_ZAR": "Zar",
    "createzullu_leverageField": "El apalancamiento es un campo requerido",
    "createzullu_accountPassword": "Contraseña de cuenta comercial",
    "createzullu_passwordcontain": "Su contraseña debe contener 6 caracteres mínimo y máximo 15 caracteres e incluye al menos 1 personaje especial (!@#$%^*/)",
    "createzullu_createAccount": "Crear una cuenta",
    "demoacc_demomsg": "La cuenta de demostración se ha creado con éxito. Tus credenciales son:",
    "demoacc_MT4": "Metatrader 4",
    "demoacc_MT5": "Metatrader 5",
    "demoacc_passwordMust": "Su contraseña debe contener 6 caracteres mínimo y 24 caracteres máximos e incluye al menos 1 personaje especial (!@#$%^*/)",
    "liveacc_accounthas": "La cuenta en vivo ha sido",
    "liveacc_successfully": "exitosamente",
    "liveacc_credentialsare": "creado. Tus credenciales son:",
    "wit_Wallet_from_wallet": "de la billetera",
    "depMsz11": "¿No es la cuenta de Skrill correcta? Por favor",
    "wit_Wallet_Back": "Volver a la billetera",
    "wit_Wallet_No": "Sin billetera",
    "wit_withdrawal": "Retiros",
    "wit_freeMargin": "Margen libre",
    "wit_withdrawalMsz1": "Lo siento, todavía no eres elegible para un retiro. ¡El depósito y el comercio pueden ayudarlo a ser elegible!",
    "wit_PrincipalWithAmount": "Monto de retiro principal",
    "wit_AccNumber": "Número de cuenta:",
    "wit_skrillId": "Skrill ID:",
    "wit_netId": "ID de Neteller:",
    "wit_creditCardNumber": "Número de Tarjeta de Crédito",
    "wit_expiryDate": "fecha de caducidad",
    "wit_allowOption": "Seleccione de las opciones permitidas anteriormente",
    "wit_WithdrawalMethodReq": "Se requiere un método de retiro",
    "wit_EnterWithdrawal": "Ingrese el retiro",
    "wit_requestWithdrawal": "Puede solicitar el retiro de las opciones de pago recién aprobadas después de 24 horas de aprobación",
    "wit_withdrawalMsz2": "Hemos recibido su solicitud de retiro y lo actualizaremos en consecuencia",
    "wit_withCont1": "FXVIEW no cobra tarifas de retiro. Sin embargo, facilite que los procesadores de pagos/intermediarios financieros pueden cobrar una tarifa de transacción.",
    "wit_withCont2": "Debido a las restricciones de transacciones de terceros, los fondos solo pueden devolverse a una cuenta bancaria en el mismo nombre que su cuenta comercial FXVIEW. Además, los fondos solo se devolverán a la misma cuenta bancaria de la que fueron recibidos.",
    "wit_withCont3": "La cantidad total que puede retirar en su tarjeta no puede exceder la cantidad total depositada con la tarjeta. Los montos que exceden este nivel se pueden retirar en su cuenta bancaria, Neteller o Skrill",
    "withdraw_backWithdraw": "Volver al retiro",
    "withdrawList": "Lista de retiros",
    "withdrawList_all": "Todo",
    "withdrawList_pending": "Pendiente",
    "withdrawList_processed": "Procesada",
    "withdrawList_rejected": "Rechazado",
    "withdrawList_created": "Fecha",
    "withdrawList_accountId": "ID de cuenta/billetera No.",
    "withdrawList_amount": "Cantidad",
    "withdrawList_currency": "Divisa",
    "withdrawList_withdrawalType": "Tipo de retiro",
    "withdrawList_method": "Método",
    "withdrawList_withdrawalStatus": "Estado",
    "withdrawList_detail": "Detalle",
    "withdrawList_viewTicket": "Ver boleto",
    "Wallet_Wallet": "Billetera",
    "Wallet_Loyalty_Points": "Puntos de lealtad",
    "Wal_detail_Add_New": "Agregar nueva moneda de billetera",
    "Wal_detail_Wallet_ID": "ID de billetera",
    "Wal_detail_Deposit": "Depósito",
    "Wal_detail_Withdraw": "Retirar",
    "Wal_detail_Transfer": "Transferir",
    "Wal_detail_curr_required": "Se requiere el campo de divisas",
    "Wal_detail_Submit": "Entregar",
    "Wal_detail_Trans_History": "Historial de transacciones",
    "Wal_detail_Date": "Fecha",
    "Wal_detail_Time": "Tiempo",
    "Wal_detail_Type": "Tipo",
    "Wal_detail_From": "De",
    "Wal_detail_To": "A",
    "Wal_detail_Amount": "Cantidad",
    "Wal_detail_Status": "Estado",
    "Wal_detail_availAmount": "Monto disponible:",
    "acc_fund_Deposit": "Depósito",
    "acc_fund_Withdrawal": "Retiro",
    "chang_wal_curr_Internal_Transf": "Transferencia interna de billetera",
    "chang_wal_curr_Transf_Wall_amount": "Cantidad de la billetera de transferencia",
    "chang_wal_curr_Back": "Volver a la billetera",
    "loyalP_Reward_Points": "Puntos de recompensa de lealtad",
    "loyalP_Know_More": "Saber más",
    "loyalP_Trans_Wallet": "Transferir a la billetera",
    "loyalP_Transfer": "Transferir",
    "loyalP_transf_TotalP": "Puntos de lealtad total",
    "loyalP_transf_Amou_Avail": "Cantidad disponible",
    "loyalP_transf_Enter_p_transfe": "Ingrese el punto a la transferencia",
    "loyalP_transf_Cancel": "Cancelar",
    "loyalP_transf_Transfer": "Transferir",
    "loyalP_transf_Back": "Volver a la billetera",
    "loyalP_transToAcc": "Transferir a la ID de billetera",
    "loyalP_fieldReq": "Se requiere campo",
    "loyalP_fieldReq_min": "Puntos de lealtad mínimo canjeables = 100 puntos de fidelización",
    "loyalP_intTransMsz2": "Haga clic en el enlace para confirmar su transferencia interna",
    "loyalP_intTransMsz3": "La transferencia se ha completado con éxito",
    "loyalP_fromTradId": "De la identificación de negociación",
    "loyalP_toTradId": "A la identificación de negociación",
    "loyalP_transferAmount": "Cantidad transferida",
    "loyal_card_det_You_are_a": "Usted es un",
    "loyal_card_det_member": "miembro",
    "loyal_card_det_Points": "Puntos",
    "loyal_card_det_Last_Credit_On": "Último crédito en",
    "loyal_card_det_Earn": "Ganar",
    "loyal_card_det_more_points_to_jump_to": "Más puntos para saltar a",
    "loyal_card_det_gain_add_benefi": "Para obtener beneficios adicionales",
    "loyal_List_Trans_History": "Historial de transacciones",
    "loyal_List_Date": "Fecha",
    "loyal_List_Activity": "Actividad",
    "loyal_List_Volume": "Volumen",
    "loyal_List_Points": "Puntos",
    "loyal_List_Cr_Db": "CR/DB",
    "loyal_ver_back": "Volver a la billetera",
    "redeamP_your_points": "Canjea tus puntos de lealtad",
    "redeamP_Points": "Puntos",
    "redeamP_Redeem": "Canjear",
    "redeamP_Red_Points": "Puntos de redimencia",
    "redeamP_Now": "Redama ahora",
    "redeamP_walletpoints": "Por favor, canjee los puntos de la billetera según los siguientes detalles <br> Puntos:",
    "redeamP_pointdesc": "<br> Point_Desc:",
    "tool_overview": "Descripción general",
    "tool_autochartistScan": "Escáner automático",
    "tool_autochartistWeb": "Web Autochartist",
    "tool_Vpsheading": "VPS",
    "tool_ecoCalendar": "Calendario económico",
    "tool_tradingToolbox": "Caja de herramientas de comerciante",
    "tool_Calculator": "Calculadores",
    "tool_tradingHOur": "Los horarios comerciales",
    "tool_Signal": "Señales",
    "autoScan_knoMore": "Saber más",
    "autoScan_DownLive": "Descargar para una cuenta en vivo",
    "autoScan_HowInstall": "Cómo instalar Autochartist",
    "autoScan_usrGuide": "guía del usuario",
    "autoScan_goTool": "En la plataforma, vaya a Herramientas> Opciones> Asesores expertos para permitir las importaciones de DLL y haga clic en Aceptar.",
    "toolVps_sureImp": "¿Está seguro de implementar esta operación?",
    "toolVps_confirm": "confirmar",
    "toolVps_cancel": "Cancelar",
    "toolVps_Shut_Down": "Cerrar",
    "toolVps_Restart": "Reanudar",
    "toolVps_Reboot": "Reiniciar",
    "toolVps_Change_Pass": "Cambiar la contraseña",
    "toolVps_VieDet": "Ver Detalle",
    "toolVps_UpdAcc": "Actualizar cuenta",
    "toolVps_Unsubscribe": "Cancelar la suscripción",
    "toolVps_vpsList": "Lista de ser servidor </span> (VPS) virtual privado",
    "toolVps_createVps": "Crear VPS",
    "toolVps_SubList": "Lista de suscripción",
    "toolVps_accWalt": "Cuenta/billetera",
    "toolVps_Priodicity": "Priodicidad",
    "toolVps_Price": "Precio",
    "toolVps_strtDate": "Fecha de inicio",
    "toolVps_endDate": "Fecha final",
    "toolVps_Action": "Acción",
    "toolVps_vps": "Virtual Private <Span> Server </span> (VPS)",
    "toolVps_vpsTilte": "Disfrute de una experiencia comercial incomparable con nosotros, donde está asegurada la estabilidad de sus operaciones. No hay necesidad de preocuparse por la latencia o tratar con múltiples software en su sistema. Use nuestros VP gratuitos para obtener respuestas rápidas de Lightning a sus oficios y disfrutar de velocidades impresionantes en nuestras plataformas.",
    "toolVps_redLate": "Latencia reducida",
    "toolVps_freeOn5000": "Gratis con un depósito de $ 5,000 o más",
    "toolVps_remoteAccess": "Acceso remoto",
    "toolVpsstab_Env": "Ambiente estable",
    "toolVps_back_vpsList": "Volver a la lista VPS",
    "toolVps_tc": "Los términos y Condiciones aplican",
    "toolVps_Plan": "Plan",
    "toolVps_Status": "Estado",
    "toolVps_type": "Tipo",
    "toolVps_nextpayment": "Siguiente pago",
    "toolVps_passWordMustContain12": "Su contraseña debe contener al menos 12 caracteres e incluir al menos 1 número, 1 carácter mayúscula y 1 carácter especial (!@#$%^&*/)",
    "toolVps_verifySubscribe": "La solicitud de su cuenta comercial de actualización se ha procesado correctamente",
    "toolVps_back_subList": "Volver a la lista de suscripción",
    "toolVps_reqProcessing": "Procesamiento de solicitud ...",
    "toolVps_reqVerify": "Verificación de solicitud",
    "toolVps_reqFailed": "Solicitud fallida",
    "VpsSub_1_Record": "Solo tienes un registro. Cree al menos una cuenta comercial o billetera más antes de intentar una cuenta de suscripción de cambio.",
    "VpsSub_liveAcc": "Cuenta en vivo",
    "VpsSub_Wallet": "Billetera",
    "VpsSub_ChangeTradAcc": "Cambiar la cuenta de negociación de suscripción",
    "VpsSub_back_subLis": "Volver a la lista de suscripción",
    "VpsSub_Submit": "Entregar",
    "VpsSub_received_request": "Hemos recibido su solicitud de cuenta comercial de Chnage y lo actualizaremos en consecuencia",
    "VpsSub_withdrawalAuthMessage": "Verifique amablemente la solicitud de retiro haciendo clic en el enlace que enviamos a su ID de correo electrónico registrada",
    "VpsSub_noTradingAccFound": "¡No se encontró una cuenta comercial en vivo!",
    "VpsUnSub_1_record": "Solo tienes un registro. Cree al menos una cuenta comercial o billetera más antes de intentar una cuenta de suscripción de cambio.",
    "VpsUnSub_liveAcc": "Cuenta en vivo",
    "VpsUnSub_Wallet": "Billetera",
    "VpsUnSub_sureUnsub": "¿Estás seguro de dar a dar de lado la suscripción?",
    "VpsUnSub_plan_": "¿plan?",
    "VpsUnSub_confirm": "confirmar",
    "VpsUnSub_Cancel": "Cancelar",
    "VpsUnSub_received_request": "Hemos recibido su solicitud de cuenta comercial de Chnage y lo actualizaremos en consecuencia",
    "VpsUnSub_back_subList": "Volver a la lista de suscripción",
    "VpsUnSubVer_successfully": "La solicitud de su plan de cancelación de suscripción se ha procesado correctamente",
    "VpsUnSubVer_back_subList": "Volver a la lista de suscripción",
    "marktTrdHour_title": "Horas de negociación del mercado",
    "marktTrdHour_txt": "El tiempo de nuestro servidor es GMT+3 durante el tiempo de ahorro de luz de día de EE. UU. (DST) y GMT+2 durante el tiempo de ahorro para no durante el día de EE. UU. (No DST).",
    "marktTrdHour_table_below": "La siguiente tabla enumera las horas de apertura y cierre de varios instrumentos y clases de activos según el tiempo de nuestro servidor.",
    "marktTrdHour_Forex": "Atropellarse",
    "marktTrdHour_Indices": "Índices",
    "marktTrdHour_Commodities": "Productos básicos",
    "marktTrdHour_Open": "Abierto",
    "marktTrdHour_Close": "Cerca",
    "marktTrdHour_Break": "Romper",
    "trdMarktPlac_title": "Comerciante <span> Market Place </span>",
    "trdMarktPlac_txt": "Explore nuestro mercado para acceder a estrategias creadas por algunos de los mejores comerciantes del mundo, o diseñe el suyo y lo ayudaremos a construirlo. Nuestro mercado es una tienda única para llevar su operación al siguiente nivel.",
    "trdMarktPlac_Automate": "Automatice su <span> comercio </span> para aprovechar al máximo los mercados",
    "trdMarktPlac_Customise": "Personaliza tu negociación",
    "trdMarktPlac_Customise_Txt": "Definir sus requisitos y dar vida a su sistema conectando con un desarrollador que lo construirá para usted",
    "trdMarktPlac_Risk_manag": "Gestión de riesgos",
    "trdMarktPlac_Risk_manag_txt": "Revise el desempeño de los proveedores de señales en función de su experiencia, las mejores y peores operaciones, el perfil de riesgo y más",
    "trdMarktPlac_Browse_library": "Explorar nuestra biblioteca",
    "trdMarktPlac_Browse_libraryTxt": "Explore nuestra extensa biblioteca de EAS e indicadores para MT4, MT5 y ActTrader, y encuentre el adecuado para sus necesidades",
    "trdMarktPlac_Categories": "Categorías",
    "trdMarktPlac_All": "Todo",
    "trdMarktPlac_Expert": "Experto",
    "trdMarktPlac_Advisors": "Asesores",
    "trdMarktPlac_Indicators": "Indicadores",
    "trdMarktPlac_ActTrader": "Acttrader",
    "trdMarktPlac_Popular": "Popular",
    "trdMarktPlac_New": "Nuevo",
    "trdMarktPlac_Free": "Gratis",
    "trdMarktPlac_Paid": "Pagado",
    "trdMarktPlac_Long_Str": "Estrategias a largo plazo",
    "trdMarktPlac_2frame": "Dos cuadros",
    "trdMarktPlac_StratCon2": "La estrategia consta de dos gráficos diferentes de historia:",
    "trdMarktPlac_Details": "Detalles",
    "trdMarktPlac_Add_List": "Agregar a la lista",
    "trdMarktPlac_Hammer_Ass": "Asistente de martillo",
    "trdMarktPlac_Strat_trad_assis": "Esta estrategia (asistente comercial) le advertirá cuándo se está formando un martillo y",
    "trdMarktPlac_Pos_Mgmt": "Gestión de puestos",
    "trdMarktPlac_Lot_Cal": "Calculadora de lote",
    "trdMarktPlac_Lot_Cal_txt": "Calculadora de lote: es una herramienta de Forex que le permite calcular el tamaño del ...",
    "trdMarktPlac_Short_Strat": "Estrategias a corto plazo",
    "trdMarktPlac_Reg_Stra": "Estrategia de regresión",
    "trdMarktPlac_Reg_StraTxt": "La estrategia abre una posición de compra cuando el bajo valor de la vela actual es = cinturón superior.",
    "trdMarktPlac_NoData": "Sin datos",
    "ecoCalendar": "Calendario económico",
    "ecoCal_Title_Txt": "Rastree eventos y lanzamientos económicos importantes que impactan por Forex, productos e índices.",
    "ecoCal_Up_next": "Hasta la próxima",
    "ecoCal_Country": "País",
    "ecoCal_Select_All": "Seleccionar todo",
    "ecoCal_Clear": "Claro",
    "ecoCal_My_Filter": "Mi filtro",
    "ecoCal_Default": "Por defecto",
    "ecoCal_Impact": "Impacto",
    "ecoCal_All": "Todo",
    "ecoCal_Medium": "Medio",
    "ecoCal_High": "Alto",
    "ecoCal_Save_filter": "Guardar la configuración en mi filtro",
    "ecoCal_Apply_Filter": "Aplicar filtro",
    "ecoCal_Time": "Tiempo",
    "ecoCal_TimeZ_Settings": "Configuración de la zona horaria",
    "ecoCal_TimeZ": "Zona horaria",
    "ecoCal_Select_TimeZ": "Selecciona la zona horaria",
    "ecoCal_TimeF": "Formato de tiempo",
    "ecoCal_Set_timeZ_Auto": "Establezca mi zona horaria automáticamente",
    "ecoCal_Save_Sett": "Guardar configuración",
    "ecoCal_Cancel": "Cancelar",
    "ecoCal_noRecord": "No hay registro",
    "ecoCal_Event": "Evento",
    "ecoCal_Actual": "Actual",
    "ecoCal_Forecast": "Pronóstico",
    "ecoCal_Previous": "Anterior",
    "tools_Trad_Tools": "Herramientas de comercio",
    "tools_Trad_Tools_Txt": "Tomar decisiones de inversión informadas y oportunas utilizando nuestras poderosas herramientas comerciales que lo ayudan a identificar oportunidades potenciales y construir una estrategia comercial más fuerte",
    "tools_Auto_Scanner": "Escáner automático",
    "tools_Auto_Scanner_txt": "Nunca vuelvas a perder una oportunidad comercial.",
    "tools_VPS": "VPS",
    "tools_VPS_txt": "Disfrute de vicepresidente básico gratuito o elija entre suscripción.",
    "tools_Eco_Calendar": "Calendario económico",
    "tools_Eco_Calendar_txt": "Manténgase actualizado sobre eventos económicos importantes.",
    "tools_Trad_Toolbox": "Caja de herramientas de comerciante",
    "tools_Trad_Toolbox_txt": "Una gama premium de herramientas de comercio y análisis.",
    "tools_Calculators": "Calculadores",
    "tools_Calculators_txt": "Calcule el valor de pip, el margen, los swaps y más.",
    "tools_TradeMarket": "Mercado del comerciante",
    "tools_TradeMarket_txt": "Encuentre su EA o indicador ideal, o tenga.",
    "tools_Trad_Hours": "Los horarios comerciales",
    "tools_Trad_Hours_txt": "Vea rápidamente cuándo los mercados están abiertos.",
    "tools_Auto_Idea": "Idea de autocartista",
    "tools_Auto_Idea_txt": "Nunca vuelvas a perder una oportunidad comercial.",
    "tools_readmore": "Leer más",
    "tools_downloa": "descargar para",
    "MT4Demo": "Demostración de MT4",
    "MT5Demo": "Demostración de MT5",
    "toolor": "o",
    "toolknowMore": "saber más",
    "chEn_entity": "Entidad",
    "chEn_global": "Fxview global",
    "chEn_europe": "FXVIEW Europa",
    "chEn_redirectmsg1": "Según su selección de país de residencia, será redirigido al sitio web de Charlgate Ltd., que está registrado en Chipre. Charlgate Ltd. se encuentra bajo el marco regulatorio europeo, y está en alcance de los mercados en la Directiva de instrumentos financieros II (MIFID II), entre otros. Además, existe una provisión para un esquema de compensación de inversores.",
    "chEn_continue": "Continuar",
    "chEn_takeback": "Llévame de vuelta",
    "adchart_create": "Crear",
    "adchart_save": "Ahorrar",
    "adchart_chart": "Cuadro",
    "adchart_Studies": "Estudios",
    "adchart_failedchart": "No se pudo cargar la tabla",
    "adchart_kindlyrefresh": "Amablemente refrescarse",
    "chart_loadchartfail": "¡No se pudo cargar la tabla amablemente actualizar!",
    "filter_Selecttimezone": "Selecciona la zona horaria",
    "filter_Low": "Bajo",
    "filter_medium": "Medio",
    "filter_high": "Alto",
    "filter_submit": "Entregar",
    "head_Wallet": "Billetera",
    "head_loyality": "Puntos de fidelidad",
    "head_createLiveAcc": "Crear cuenta en vivo",
    "head_createDemoAcc": "Crear cuenta de demostración",
    "head_Notification": "Notificación",
    "head_seeAll": "Ver todo",
    "head_noNewNotification": "No hay notificaciones nuevas",
    "head_verified": "Verificado",
    "head_deposit_enabled": "Depósito habilitado",
    "head_notVerified": "No verificado",
    "head_profile": "Perfil",
    "head_changePassword": "Cambiar la contraseña",
    "successMsz4": "Contraseña cambiada con éxito",
    "head_security": "Seguridad",
    "head_referFriend": "Recomendar un amigo",
    "head_logout": "Cerrar sesión",
    "leftnav_dashboard": "Panel",
    "leftnav_wallet": "Billetera",
    "leftnav_accfunding": "Financiación de la cuenta",
    "leftnav_manageAcc": "Administrar cuenta",
    "leftnav_Depositbonus": "Bono de depósito",
    "leftnav_socialTrade": "Comercio social",
    "leftnav_tools": "Herramientas",
    "leftnav_education": "Educación &",
    "leftnav_resources": "Recursos",
    "leftnav_downloadplatform": "Plataforma de descarga",
    "leftnav_support": "Apoyo",
    "load_norecordfound": "No se encontraron registros",
    "tradAcc_application": "Complete su solicitud de cuenta y cree un",
    "tradAcc_application1": "Complete su solicitud de cuenta para acceder a esta función",
    "tradAcc_trading": "comercio",
    "tradAcc_live": "vivir",
    "tradAcc_accountAccess": "cuenta para acceder a esta función.",
    "tradAcc_resumeApplication": "Solicitud de reanudación",
    "tradAcc_checkappStatus": "Su solicitud está en revisión, verifique el estado de su boleto.",
    "tradAcc_ticket": "Boleto",
    "tradAcc_createliveAcc": "Cree una cuenta en vivo para acceder a esta función",
    "tradAcc_liveDemoAcc": "Cree una cuenta de demostración o en vivo para acceder a esta función",
    "tradAcc_demoAcc": "Cuenta de demostración",
    "tradAcc_createWallet": "Crea una billetera para acceder a esta función",
    "tradAcc_wallet": "Billetera",
    "pagin_totalRecords": "Total de registros",
    "acclist_fund": "Fondo",
    "acclist_addFund": "Añadir fondos",
    "acclist_addFundTo": "Agregar fondos a",
    "acclist_tradingId": "ID de negociación",
    "acclist_addingFundTo": "Agregar fondos a",
    "acclist_fund_msz": "depósito exitoso",
    "acclist_fund_mszErr": "depositar sin éxito",
    "acclist_changeLeverage": "Cambio de apalancamiento",
    "acclist_changePassword": "Cambiar la contraseña",
    "acclist_internalTransfer": "Transferencia interna",
    "acclist_tradeNow": "Negocia ahora",
    "acclist_detachAcc": "Separar la cuenta",
    "accId_TransFromAccId": "Transferencia de la ID de cuenta",
    "accId_selectAccountId": "Seleccionar ID de cuenta",
    "accId_fieldReq": "Se requiere campo",
    "closetrad_login": "Acceso",
    "closetrad_order": "Orden",
    "closetrad_symbol": "Símbolo",
    "closetrad_volume": "Volumen",
    "closetrad_openPrice": "Precio de apertura",
    "closetrad_openTime": "Tiempo abierto",
    "closetrad_commision": "Comisión",
    "closetrad_type": "Tipo",
    "closetrad_SL": "SLE",
    "closetrad_TP": "TP",
    "closetrad_closePrice": "Precio cercano",
    "closetrad_closeTime": "Hora de cierre",
    "closetrad_Swap": "Intercambio",
    "closetrad_PNL": "PNL",
    "closetrad_comment": "Comentario",
    "closetrad_price": "Precio",
    "OCtradelist_balance": "Balance",
    "OCtradelist_margin": "Margen",
    "OCtradelist_equity": "Equidad",
    "OCtradelist_pnl": "PNL",
    "OCtradelist_tradeNow": "Negocia ahora",
    "OCtradelist_opentrade": "Comercio abierto",
    "OCtradelist_closetrade": "Comercio cercano",
    "openOrder_orderId": "Solicitar ID",
    "openOrder_accountId": "ID de la cuenta",
    "openOrder_quantity": "Cantidad",
    "openOrder_triggered": "Motivado",
    "openOrder_side": "Lado",
    "openOrder_tradeId": "ID de comercio",
    "openOrder_profit": "Ganancia",
    "openOrder_agentComm": "Agente de comisión",
    "openOrder_cmd": "CMD",
    "openOrder_sl": "SLE",
    "openOrder_tp": "TP",
    "openOrder_swaps": "Swaps",
    "trade_cal_title": "Calculadoras comerciales",
    "trade_cal_title_Txt": "Nuestras calculadoras en línea le proporcionan una manera fácil de analizar las operaciones que planea hacer. Le ayudamos a calcular los valores basados ​​en las condiciones del mercado y le brindamos resultados instantáneos.",
    "trade_cal_Commission": "Comisión",
    "trade_cal_Multi_Target": "Múltiple",
    "trade_cal_Pivot_Points": "Puntos de pivote",
    "trade_cal_Profit_Loss": "Pérdida de beneficios",
    "trade_cal_Fibonacci": "Fibonacci",
    "trade_cal_Pip_Value": "Valor de pip",
    "trade_cal_Swap": "Intercambio",
    "trade_cal_Position_Size": "Tamaño de posición",
    "trade_cal_Currency_Convertor": "Convertidor de divisas",
    "cal_comm_title": "Comisión",
    "cal_comm_title_txt": "Calcule las comisiones que pagaría por una operación con nuestra calculadora de comisiones. FXVIEW cobra una comisión de $ 1/100,000 en cada sentido (o $ 2/100,000 de ida y vuelta). Nuestra calculadora de comisiones lo ayudará a calcular cuánto funciona esto, para cualquier comercio. Simplemente ingrese la clase de activos, el símbolo, la moneda base de cuentas y el tamaño comercial, y presione 'Calcule ahora'.",
    "cal_comm_forex": "atropellarse",
    "cal_comm_commodities": "productos básicos",
    "cal_comm_indices": "índices",
    "cal_comm_Asset_Class": "Clase de activos",
    "cal_comm_Field_req": "Se requiere campo",
    "cal_comm_USD": "Dólar estadounidense",
    "cal_comm_GBP": "GBP",
    "cal_comm_AUD": "Audio",
    "cal_comm_EUR": "EUR",
    "cal_comm_accBaseCurr": "Moneda base de cuentas",
    "cal_comm_Symbol": "Símbolo",
    "cal_comm_trade_size_lot": "Tamaño del comercio (en lotes)",
    "cal_comm_now": "Calcular ahora",
    "cal_comm_Comm_roundT": "Comisión (viaje de ida y vuelta)",
    "cal_marg_title": "Margen",
    "cal_marg_title_txt": "La calculadora de margen lo ayuda a determinar el margen requerido para abrir una posición. Simplemente seleccione la clase de activos, el símbolo, la moneda de cuentas y el tamaño comercial para determinar el margen requerido basado dependiendo del apalancamiento máximo ofrecido para diferentes tipos de instrumentos.",
    "cal_marg_Field_req": "Se requiere campo",
    "cal_marg_accBaseCurr": "Moneda base de cuentas",
    "cal_marg_Symbol": "Símbolo",
    "cal_marg_trade_size_lot": "Tamaño del comercio (en lotes)",
    "cal_marg_now": "Calcular ahora",
    "cal_marg_req": "Margen requiere",
    "cal_marg_max_lev": "Max. Aprovechar",
    "cal_marg_forex": "atropellarse",
    "cal_marg_commodities": "Productos básicos",
    "cal_marg_indices": "Índices",
    "cal_milti_Target": "Múltiple objetivo",
    "cal_milti_Target_txt": "Esta calculadora ayuda a los operadores a planificar qué parte de sus posiciones deberían cerrarse en ciertos niveles objetivo para obtener la mejor relación de retorno al riesgo posible.",
    "cal_milti_Field_req": "Se requiere campo",
    "cal_milti_accBaseCurr": "Moneda base de cuentas",
    "cal_milti_Symbol": "Símbolo",
    "cal_milti_Position_Type": "Tipo de Posición",
    "cal_milti_Buy": "Comprar",
    "cal_milti_Sell": "Vender",
    "cal_milti_Open_Price": "Precio de apertura",
    "cal_milti_Stop_loss_Price": "Detener el precio de la pérdida",
    "cal_milti_trade_size_lot": "Tamaño del comercio (en lotes)",
    "cal_milti_Target_Price": "Precio objetivo",
    "cal_milti_lots_Clos_Target": "lotes cerrados en el objetivo",
    "cal_milti_Net_Lot_size": "Tamaño del lote de la red:",
    "cal_milti_Now": "Calcular ahora",
    "cal_milti_Target_Profit": "Beneficio objetivo",
    "cal_milti_Total_Profit": "Beneficio total",
    "cal_milti_Return_Risk": "Volver al riesgo",
    "cal_pivot_point_txt": "FXVIEW ofrece una calculadora de puntos de pivote para ayudarlo a identificar la dirección de las tendencias prevalecientes y determinar los niveles de soporte y resistencia.",
    "cal_pivot_High": "Alto",
    "cal_pivot_Low": "Bajo",
    "cal_pivot_Open": "Abierto",
    "cal_pivot_Close": "Cerca",
    "cal_pivot_Calculate_Now": "Calcular ahora",
    "cal_pivot_Clear": "Claro",
    "cal_pivot_CLASSIC": "CLÁSICO",
    "cal_pivot_WOODIE": "Woodie",
    "cal_pivot_CAMARILLA": "CAMARILLA",
    "cal_pivot_DMARKS": "Dmarks's",
    "cal_pivot_Resistance": "Resistencia",
    "cal_pivot_Pivot_Points": "Puntos de pivote",
    "cal_pivot_Support": "Apoyo",
    "cal_pivot_Field_req": "Se requiere campo",
    "cal_pivot_PivotPoints": "Puntos de pivote",
    "cal_profit_Loss": "Pérdida de beneficios",
    "cal_profitL_Txt": "La calculadora de ganancias y pérdidas de FXVIEW es una herramienta básica que puede ayudarlo a calcular las ganancias o pérdidas de un comercio. Simplemente seleccione la clase de activos, el símbolo, la moneda base de cuentas, los precios de apertura y cierre deseados, el tipo de posición y el tamaño comercial en lotes, y presione 'Calcule ahora'.",
    "cal_profitLField_req": "Se requiere campo",
    "cal_profitL_accBaseCurr": "Moneda base de cuentas",
    "cal_profitL_Symbol": "Símbolo",
    "cal_profitL_Pos_Type": "Tipo de Posición",
    "cal_profitL_Buy": "Comprar",
    "cal_profitL_Sell": "Vender",
    "cal_profitL_Open_Price": "Precio de apertura",
    "cal_profitL_Close_Price": "Precio cercano",
    "cal_profitL_trade_size_lot": "Tamaño del comercio (en lotes)",
    "cal_profitL_Now": "Calcular ahora",
    "cal_Fibonacci": "Fibonacci",
    "cal_fibo_txt": "Con la calculadora Fibonacci de FXVIEW, puede calcular los retacos de Fibonacci basados ​​en los puntos extremos de un gráfico en una tendencia alcista o una tendencia inferior. Simplemente coloque los valores altos y bajos para comenzar.",
    "cal_fibo_Uptrend": "Tendencia alcista",
    "cal_fibo_Downtrend": "Tendencia a la baja",
    "cal_fibo_Field_req": "Se requiere campo",
    "cal_fibo_High": "Alto",
    "cal_fibo_Low": "Bajo",
    "cal_fibo_Now": "Calcular ahora",
    "cal_fibo_Retracements": "Retracciones",
    "cal_fibo_Support": "Apoyo",
    "cal_Pip_Value": "Valor de pip",
    "cal_Pip_txt": "Una herramienta efectiva para administrar su estrategia de riesgo, nuestra calculadora de valor PIP le permite calcular el valor por PIP de cada posición. Con esta herramienta, puede monitorear su riesgo para cada operación con más precisión.",
    "cal_Pip_Field_req": "Se requiere campo",
    "cal_Pip_accBaseCurr": "Moneda base de cuentas",
    "cal_Pip_Symbol": "Símbolo",
    "cal_Pip_trade_size_lot": "Tamaño del comercio (en lotes)",
    "cal_Pip_Now": "Calcular ahora",
    "cal_swap": "Intercambio",
    "cal_swap_txt": "Se pueden considerar los swaps como el costo de financiación de mantener un puesto abierto. Pueden ser positivos o negativos, se les paga/reciben cuando una posición se mantiene abierta durante la noche. Son diferentes para posiciones largas y cortas, y varían en diferentes instrumentos.",
    "cal_swap_MT4_MT5": "MT4/MT5",
    "cal_swap_ACT": "ACTO",
    "cal_swap_Field_req": "Se requiere campo",
    "cal_swap_accBaseCurr": "Moneda base de cuentas",
    "cal_swap_Symbol": "Símbolo",
    "cal_swap_Num_Days": "Número de días",
    "cal_swap_trade_size_lot": "Tamaño del comercio (en lotes)",
    "cal_swap_Swap_Long": "> Intercambiar largo",
    "cal_swap_Swap_Short": "Intercambio",
    "cal_Position_Size": "Tamaño de posición",
    "cal_position_txt": "La calculadora de tamaño de posición de FXVIEW le ayuda a calcular cuántos lotes de una posición puede abrir, dada una cantidad predeterminada que está dispuesto a arriesgarse a perder. Simplemente especifique la clase de activos, la moneda base de cuentas, el símbolo, el tipo de posición, el precio abierto y la pérdida de parada, el saldo de la cuenta y el porcentaje de riesgo (es decir, el porcentaje del saldo de su cuenta que está dispuesto a arriesgarse a perder), luego presione 'Calcule ahora. '",
    "cal_position_Field_req": "Se requiere campo",
    "cal_position_accBaseCurr": "Moneda base de cuentas",
    "cal_position_Symbol": "Símbolo",
    "cal_position_Position_Type": "Tipo de Posición",
    "cal_position_BUY": "COMPRAR",
    "cal_position_SELL": "VENDER",
    "cal_position_Open_Price": "Precio de apertura",
    "cal_position_Account_Balance": "Saldo de la cuenta",
    "cal_position_Stop_Loss": "Detener la pérdida de",
    "cal_position_Risk_Perc": "Porcentaje de riesgo",
    "cal_position_trade_size_lot": "Tamaño de comercio en lotes",
    "cal_position_Now": "Calcular ahora",
    "cal_curr_Convertor": "Convertidor de divisas",
    "cal_curr_conv_txt": "El convertidor de divisas de FXVIEW permite a los usuarios verificar el valor de una moneda con respecto a otras en función de los tipos de cambio actuales. Con nuestro convertidor de divisas, puede convertir dos monedas con solo unos pocos clics.",
    "cal_curr_conv_From": "Moneda de",
    "cal_curr_conv_To": "Moneda a",
    "cal_curr_conv_Amount": "Cantidad",
    "cal_curr_conv_Field_req": "Se requiere campo",
    "cal_curr_conv_Now": "Calcular ahora",
    "cal_curr_conv_Converted": "Moneda convertida",
    "cal_leftmenu_commision": "Comisión",
    "cal_leftmenu_margin": "Margen",
    "cal_leftmenu_multiTarget": "Múltiple",
    "cal_leftmenu_pivotpoints": "Puntos de pivote",
    "cal_leftmenu_profitloss": "Pérdida de beneficios",
    "cal_leftmenu_fibonacci": "Fibonacci",
    "cal_leftmenu_pipValue": "Valor de pip",
    "cal_leftmenu_Swap": "Intercambio",
    "cal_leftmenu_positionSize": "Tamaño de posición",
    "cal_leftmenu_currencyConv": "Convertidor de divisas",
    "suppIndex_requestServices": "Apoyo",
    "suppIndex_OpenRequests": "Boletos abiertos",
    "suppIndex_ClosedRequests": "Boletos cerrados",
    "suppReqService_support": "Apoyo",
    "suppReqService_howassist": "Cómo podemos ayudarle?",
    "suppReqService_emailus": "Envíanos un correo electrónico",
    "suppReqService_email": "info@fxview.com",
    "suppReqService_liveChat": "Chat en vivo",
    "suppReqService_avail24": "Disponible las 24 horas, los 7 días de la semana",
    "suppReqService_requestcallback": "Solicitar devolución de llamada",
    "suppReqService_office": "Oficina: +442031505221",
    "suppReqService_support_phn": "Soporte: +442031505221",
    "suppReqService_createTicket": "Crear un boleto de soporte",
    "suppReqService_helpSupport": "¿Cómo podemos ayudar?",
    "suppReqService_back": "Atrás",
    "suppReqService_AddPaymentMethod": "Añadir método de pago",
    "ZULU": "ZULÚ",
    "MQL5": "MQL5",
    "depositBonus": "Bono de depósito",
    "referfriend": "Recomendar un amigo",
    "supp_Wallet": "Billetera",
    "contactReq": "Se requiere el tiempo de contacto.",
    "support_ticketNumber": "Numero de ticket",
    "support_reason": "Razón",
    "support_created": "Fecha",
    "support_action": "Acción",
    "suppview_backToTicket": "Apoyar el hogar",
    "suppview_thankyou": "¡Gracias por verificar su identidad y bienvenido a FXVIEW! Ahora puede abrir una cuenta comercial en vivo y comenzar a operar.",
    "suppview_createliveAcc": "Crear cuenta en vivo",
    "suppview_whilevalidate1": "Al validar su documento de prueba de dirección, notamos que la dirección y el número de identificación ingresado durante el registro no coinciden con el documento cargado durante la verificación.",
    "suppview_whilevalidate2": "Al validar su documento de prueba de dirección, notamos que la dirección ingresada durante el registro no coincide con el documento cargado durante la verificación.",
    "suppview_whilevalidate3": "Al validar su documento de prueba de dirección, notamos que el número de identificación ingresado durante el registro no coincide con el documento cargado durante la verificación.",
    "suppview_originalAdress": "direccion original",
    "suppview_stepMsz18": "No quiero cambiar nada",
    "suppview_preQues": "Pregunta anterior",
    "suppview_nextQues": "Próxima pregunta",
    "suppview_stepMsz21": "Resolver el conflicto",
    "suppview_idNumEnt": "Número de identificación ingresado",
    "suppview_percentComplete": "% Completo",
    "suppview_nationalityEntered": "Nacionalidad ingresada",
    "suppview_fillone": "Por favor llene al menos un campo",
    "otpVerif_otpVerification": "Verificación OTP",
    "otpVerif_otpVerificationText1": "Se ha enviado un PIN único a su correo electrónico.",
    "otpVerif_resendOtpTicket": "¿No ha recibido un correo electrónico en su bandeja de entrada o carpeta de spam? Revender",
    "otpVerif_back": "atrás",
    "otpVerif_backToTicket": "Apoyar el hogar",
    "profileReq_getHelpWith": "Obtener ayuda con",
    "profileReq_Queries": "Consultas relacionadas",
    "profileReq_relatedTopics": "Temas relacionados",
    "profileReq_inversterPass": "En caso de que si enfrenta algún problema establecer la contraseña del inversor desde su plataforma MT4/MT5, continúe con la creación de la solicitud de soporte",
    "profileReq_notSatisfied": "no estoy satisfecho",
    "profileReq_lodgeComplaint": "Presentar una queja",
    "profileReq_helpUsWithYour": "Ayúdanos con tu",
    "profileReq_askOtherQuestions": "Haznos cualquier otra pregunta",
    "profileReq_AddBankDetails": "Agregar datos bancarios",
    "profileReq_AddSkrillDetails": "Agregar detalles de identificación de Skrill",
    "profileReq_AddNetellerDetails": "Agregar detalles de identificación de Neteller",
    "profileReq_AddCreditCardDetails": "Agregar datos de la tarjeta de crédito",
    "profileReq_inn": "en",
    "profileReq_emailHeading": "Ingrese su nueva identificación de correo electrónico a continuación",
    "profileReq_exsistsEmailAddress": "Dirección de correo electrónico existente",
    "profileReq_newEmail": "Ingrese su nueva dirección de correo electrónico",
    "profileReq_EmailfieldValid": "Por favor, introduce una dirección de correo electrónico válida",
    "profileReq_EmailfieldReq": "Se requiere un campo de correo electrónico",
    "profileReq_changeEmailAddress": "Cambiar la dirección de correo electrónico",
    "profileReq_mobileHeading": "Ingrese su nuevo número de móvil a continuación",
    "profileReq_existingMobileNumber": "Número de móvil existente",
    "profileReq_InvalidNumber": "Número invalido",
    "profileReq_changeMobileNumber": "Cambiar el número de móvil",
    "profileReq_postCodeRequired": "Se requiere el código postal",
    "profileReq_residenceCountryRequired": "Se requiere el país de residencia",
    "profileReq_uploadRecentAddressProof": "Cargue la prueba de dirección reciente",
    "profileReq_docReq": "se requiere documento",
    "profileReq_changeAddress": "Cambiar dirección",
    "profileReq_bankName": "Nombre del banco:",
    "profileReq_AccountName": "Nombre de la cuenta",
    "profileReq_bankNameRequired": "Se requiere el nombre del banco",
    "profileReq_accountHolderRequired": "Se requiere el nombre del titular de la cuenta",
    "profileReq_AccNumber": "Número de cuenta:",
    "profileReq_accountNumberRequired": "Se requiere el número de cuenta",
    "profileReq_country": "País",
    "profileReq_countryFieldRequired": "Se requiere el campo del país",
    "profileReq_IBAN": "Iban",
    "profileReq_ibanRequired": "Se requiere el Iban",
    "profileReq_MyBankNotIBAN": "Mi banco no le da a Iban",
    "profileReq_SwiftCode": "Código Swift/Bic/Sort",
    "profileReq_swiftCodeRequired": "Se requiere el código Swift",
    "profileReq_bankAdd": "Dirección bancaria:",
    "profileReq_bankAddressRequired": "Se requiere la dirección bancaria",
    "profileReq_UpBankStatement": "Subir el estado de cuenta bancaria",
    "profileReq_fileallow": "¡Solo se permiten JPG, JPEG, PNG, PDF, DOCX, DOC, XLS, XLSX!",
    "profileReq_addNewBank": "Agregar una nueva cuenta bancaria",
    "profileReq_last4Digit": "Se requieren los últimos 4 dígitos y contiene solo carácter numérico",
    "profileReq_first4Digit": "Se requieren los primeros 4 dígitos y contiene solo carácter numérico",
    "profileReq_frontBack": "Requerimos lo siguiente para la verificación de la tarjeta -",
    "profileReq_frontPhotoCredit": "Copia en color de la parte frontal de la tarjeta, que muestra: nombre completo, fecha de vencimiento, nombre/logotipo del banco, primeros 4 y los últimos 4 dígitos del número de tarjeta de crédito que oculta los 8 dígitos intermedios.",
    "profileReq_uploadSupportingDocument": "Subir un documento de apoyo",
    "profileReq_backPhotoCredit": "Copia en color de la parte posterior de la tarjeta que oculta el código de seguridad CVV. La copia posterior debe mostrar el signo del titular",
    "profileReq_submit": "Entregar",
    "profileReq_paymentRequiredNumeric": "Se requiere el campo de identificación de pago y solo puede contener caracteres numéricos.",
    "profileReq_netSkrill1": "Sube la captura de pantalla del",
    "profileReq_netSkrill2": "perfil contactando el nombre completo,",
    "profileReq_netSkrill3": "ID y dirección. Vamos a igualar el nombre y la dirección",
    "profileReq_userDetails": "Detalles de usuario",
    "profileReq_ComplaintDetails": "Detalles de la queja",
    "profileReq_employeeWhoOffered": "Empleado que ofreció los servicios al cliente:",
    "profileReq_timeDisputed": "Fecha y hora de la situación en disputa (en la hora del servidor de Metatrader):",
    "profileReq_TheDisputeTime": "Se requiere el tiempo de disputa",
    "profileReq_ticNoContested": "Número (s) de boletos de todas las posiciones disputadas y/o pedidos pendientes:",
    "profileReq_DisputedAmount": "Cantidad en disputa:",
    "profileReq_reportComplaint": "¿Ha informado su queja a cualquier autoridad de supervisión?",
    "profileReq_stateNameAuth": "Indique el nombre de la autoridad de supervisión",
    "profileReq_TheAuthorityName": "Se requiere el nombre de la autoridad",
    "profileReq_DetailedDescript": "Descripción detallada de la queja:",
    "profileReq_attachTogetherForm": "Adjunte con este formulario cualquier evidencia de apoyo a su reclamo que facilite la investigación de FXVIEW de su queja. La evidencia de apoyo puede consistir en cualquier documentación (capturas de pantalla, chats, registros telefónicos, etc.) relevante para la queja.",
    "profileReq_Subject": "Sujeto",
    "profileReq_yourMsz": "Tu mensaje",
    "profileReq_ticketHasbeenComplaint": "Su queja ha sido registrada con éxito",
    "profileReq_ticketHasbeenCreated": "Tu boleto ha sido creado",
    "profileReq_proMsz19": "Ir a las entradas",
    "profileReq_entervalidcard": "Ingrese el número de tarjeta válido",
    "profileReq_changeEmail": "Cambie mi correo electrónico según los siguientes detalles <br> Correo electrónico antiguo:",
    "profileReq_NEWEmail": "<br> nuevo correo electrónico:",
    "profileReq_changeMobile": "Cambie mi número de móvil según los siguientes detalles <br> Número anterior:",
    "profileReq_newNumber": "<br> Número nuevo:",
    "profileReq_changebankinfo": "Cambie mi información bancaria según los siguientes detalles <br> Número de cuenta:",
    "profileReq_holdername": "<br> Nombre del titular:",
    "profileReq_bankname": "<br> Nombre del banco:",
    "profileReq_bankcode": "<br> Código bancario:",
    "profileReq_sortcode": "<br> Código de clasificación:",
    "profileReq_bankAddress": "<br> Dirección bancaria:",
    "profileReq_changeadress": "Cambie mi dirección según los siguientes detalles <br> Dirección1:",
    "profileReq_adresstwo": "<br> Dirección2:",
    "profileReq_postcode": "<br> Código postal:",
    "profileReq_residenceCountry": "<br> país de residencia:",
    "profileReq_nation": "<br> Nacionalidad:",
    "profileReq_City": "<br> Ciudad:",
    "profileReq_pleaseAdd": "Por favor añadir",
    "profileReq_paymentmethod": "Método de pago según los siguientes detalles <br>",
    "profileReq_number": "Número :",
    "profileReq_expiryDate": "<br> Fecha de vencimiento:",
    "profileReq_id": "Identificación :",
    "autoscan_AutochartistScanner": "Escáner automático",
    "autoscan_IBintegrateAdvancedTool": "Autochartist es un software de reconocimiento de patrones de la tabla principal que escanea los instrumentos de comercio y reconoce automáticamente las configuraciones comerciales en función de los brotes, los retractores, el soporte y los niveles de resistencia para que nunca vuelva a perder una oportunidad.",
    "autoscan_closeMt4": "Inicie sesión en su cuenta FXView MT4.",
    "autoscan_DownloadRunAuto": "Descargue y ejecute la aplicación de escáner Autochartist.",
    "autoscan_SelectPortfoliosTrading": "Seleccione la plataforma FXView MT4 y continúe con la instalación.",
    "autoscan_RestartMt4Platform": "Reiniciar la plataforma FXView MT4.",
    "autoscan_autochartistdesc": "El escáner automático se puede usar en la cuenta Live MT4 con un monto mínimo de depósito de $ 200.",
    "autoscan_DisclaimerAutoChartist": "Descargo de responsabilidad: las publicaciones en esta página se consideran comunicación de marketing y no contienen, y no deben interpretarse como contenidos, asesoramiento de inversión o una recomendación de inversión o una oferta o solicitud para cualquier transacción en instrumentos financieros. El rendimiento pasado no es indicativo de resultados futuros. Busque consejos independientes si es necesario.",
    "autochar_autocharist": "Cartista de automóviles",
    "autochar_CreateLiveAccount": "Crear cuenta en vivo",
    "autochar_Cancel": "Cancelar",
    "subVerf_reqVerify": "Verificación de solicitud",
    "subVerf_dear": "Estimado",
    "subVerf_your": "su",
    "subVerf_accountVerMsz1": "la solicitud ha sido procesada con éxito",
    "subVerf_backSubList": "Volver a las herramientas de susbcription",
    "subtrans_heading": "Detalle de la transacción de suscripción",
    "subtrans_date": "Fecha de creacion)",
    "subtrans_payType": "Tipo de pago",
    "subtrans_planprice": "Precio del plan",
    "subtrans_coupon": "Cupón",
    "subtrans_amount": "Cantidad",
    "subtrans_noData": "sin datos",
    "subtrans_backVPSlist": "Volver a la lista VPS",
    "vpsdetail_heading": "Detalles de VPS",
    "vpsdetail_IPAddress": "Dirección IP",
    "vpsdetail_ServerId": "ID de servidor",
    "vpsdetail_HostName": "Nombre de host",
    "vpsdetail_Disk": "Disco",
    "vpsdetail_Cpu": "UPC",
    "vpsdetail_Memory": "Memoria",
    "vpsdetail_State": "Estado",
    "vpsdetail_Created": "Fecha",
    "vpsdetail_action": "Acción",
    "toolbox_tradeToolbox": "Caja de herramientas del comerciante",
    "toolbox_moreAboutTradeToolbox": "Encuentra más sobre la caja de herramientas de Trader",
    "toolbox_tradeToolMsz1": "Enriquezca su operación con la caja de herramientas de FXView Trader: un conjunto de indicadores y aplicaciones robustas que agrega conveniencia a su viaje de negociación.",
    "toolbox_WhatYouGet": "Lo que obtienes",
    "toolbox_TraderToolboxApp": "Aplicación de caja de herramientas del operador",
    "toolbox_TradeTerminal": "Terminal comercial",
    "toolbox_MiniTerminal": "Mini terminal",
    "toolbox_AlarmsManager": "Gerente de alarmas",
    "toolbox_ExcelRTD": "Excel RTD",
    "toolbox_Connect": "Conectar",
    "toolbox_SentimentTrader": "Comerciante de sentimientos",
    "toolbox_SessionMap": "Mapa de sesión",
    "toolbox_MarketManager": "Gerente de mercado",
    "toolbox_CorrelationMatrix": "Matriz de correlación",
    "toolbox_CorrelationTrader": "Comerciante de correlación",
    "toolbox_TickTrader": "Comerciante",
    "toolbox_StealthOrder": "Orden de sigilo",
    "toolbox_IndicatorPackage": "Paquete indicador",
    "toolbox_Minichart": "Mini gráfico",
    "toolbox_PivotPoints": "Puntos de pivote",
    "toolbox_HighsLows": "Altas y bajas",
    "toolbox_Renkobars": "Bares de Renko",
    "toolbox_ChartGroup": "Grupo de gráficos",
    "toolbox_SymbolInfo": "Información de símbolos",
    "toolbox_Gravity": "Gravedad",
    "toolbox_Chart_in_Chart": "Gráfico",
    "toolbox_PeriodConverter": "Convertidor de época",
    "toolbox_Magnifier": "Lupa",
    "toolbox_OrderHistory": "Historial de pedidos",
    "toolbox_FreehandDrawing": "Dibujo a mano alzada",
    "toolbox_BarChanger": "Cambiador",
    "toolbox_KeltnerChannel": "Canal Keltner",
    "toolbox_DonchianChannel": "Canal de donchian",
    "toolbox_CandleCountdown": "Cuenta regresiva para velas",
    "toolbox_LinearRegression": "Regresión lineal",
    "toolbox_howtoinstall": "Cómo instalar la caja de herramientas del comerciante",
    "toolbox_loginFxViewmt45": "Inicie sesión en su cuenta FXVIEW MT5",
    "toolbox_ToolboxApplication": "Descargar y ejecutar la aplicación de caja de herramientas de comerciante MT5",
    "toolbox_FxviewMT45installation": "Seleccione la plataforma FXVIEW MT5 y continúe con la instalación",
    "toolbox_allowDdlImports": "Haga clic en Herramientas> Opciones> Asesor de expertos> y luego haga clic en Aceptar para permitir las importaciones de DDL",
    "toolbox_RestartFxviewMT45": "Reiniciar la plataforma FXView MT5",
    "toolbox_tradeToolboxliveMinDeposit": "La aplicación de caja de herramientas del operador se puede usar en la cuenta Live MT5 con un monto mínimo de depósito de $ 500.",
    "toolbox_DisclaimerAutoChartist": "Descargo de responsabilidad: las publicaciones en esta página se consideran comunicación de marketing y no contienen, y no deben interpretarse como contenidos, asesoramiento de inversión o una recomendación de inversión o una oferta o solicitud para cualquier transacción en instrumentos financieros. El rendimiento pasado no es indicativo de resultados futuros. Busque consejos independientes si es necesario.",
    "subscription_Subscriptionheading": "Suscripciones",
    "subscription_SubMsz": "Tome su plan deseado para obtener acceso a nuestro contenido fácilmente, nos gusta ofrecer una oferta de licencia especial a nuestros usuarios.",
    "subscription_mnth": "/Mes",
    "subscription_freeMin": "Gratis - min",
    "subscription_deposit": "Depósitos",
    "subscription_Features": "Características",
    "subscription_window": "ventana",
    "subscription_Memory": "Memoria",
    "subscription_ssdDisk": "Disco SSD",
    "subscription_create": "Crear",
    "subticket_getSubPlan": "Obtenga suscripción para este plan",
    "subticket_applyCouponCode": "Código de cupón aplicado:",
    "subticket_TotalAmount": "Cantidad total",
    "subticket_havePromoCode": "¿Tienes un código de promoción?",
    "subticket_deducedMonthlySubscription": "Seleccione la ID de negociación desde donde desea que se deduzca el costo para la suscripción mensual en caso de que no se cumplan las condiciones mínimas para VP gratuitos.",
    "subticket_demo": "Manifestación",
    "subticket_live": "Vivir",
    "subticket_noteUnsubTool": "Nota: El pago solo se deducirá una vez que haga clic en la suscripción",
    "subticket_clickToAgree": "Haga clic aquí para estar de acuerdo",
    "subticket_vpsTC": "VPS T&C.",
    "subticket_linkToSub": "Haga clic en ese enlace para suscribirse.",
    "subticket_subsucce": "ha sido suscrito con éxito. Para saber más detalles, haga clic en el botón a continuación",
    "subticket_AutoChartPage": "Vaya a la página de Auto Chartist",
    "subticket_controlsignalPage": "Vaya a la página de la señal de control",
    "subticket_researchReportpage": "Ir a la página de informes de investigación",
    "subticket_currentNewsPage": "Ir a la página de noticias actuales",
    "subticket_economicCalPage": "Vaya a la página de calendario económico",
    "subticket_vpsPage": "Ir a la página VPS",
    "subticket_selectPromoCode": "Seleccione un código de promoción",
    "subticket_EnterCouponCode": "Introduce el código de cupón",
    "subticket_Apply": "Aplicar",
    "subticket_For": "Para",
    "subticket_noPromoCode": "¡No tienes ningún promoción todavía!",
    "subticket_vpsSubPlan": "Suscripción del plan VPS",
    "subticket_createVPS": "Agregue fondos para crear VPS",
    "subticket_goDepositPage": "Ir a la página de depósito",
    "noTradingCreateNewOne": "No hay cuenta comercial todavía, cree una nueva cuenta",
    "faMszOtp1": "o uso también puede usar 2FA OTP, pero primero debe habilitar haciendo clic en el enlace que se da a continuación",
    "RESEND_EMAIL": "Reenviar email",
    "TECH_ERROR": "Nos enfrentamos a algunos problemas, por favor intente después de un tiempo",
    "VALIDATION_ERROR": "Error de validacion",
    "INVALID_TRADING_ACC": "Error de cuenta comercial no válido",
    "INVALID_WITHDRAWAL_TRANSACTION": "transacción de retiro no válida",
    "INVALID_OTP": "OTP no válido",
    "FILE_UPLOAD": "¡Solo se permiten archivos JPG, JPEG, PNG, PDF!",
    "OTP_EXPIRED": "OTP expiró",
    "OTP_IP_MISMATCH": "OTP no coincide",
    "LOW_BALANCE_THEN_AMOUNT": "La cantidad que ha ingresado es mayor que el margen gratuito disponible.",
    "TICKET_EXIST": "El boleto ya existe",
    "EMAIL_EXIST": "El correo electrónico ya existe",
    "MOBILE_EXIST": "El número de móvil ya existe",
    "LOW_BONUS_THEN_AMOUNT": "la cantidad que ha llenado es baja que su bonificación",
    "INVALID_ACCOUNT_TRANSACTION": "transacción de cuenta inválida",
    "INVALID_TICKET_TRANSACTION": "transacción de boletos no válidos",
    "DEPOSIT_LIMIT": "límite de depósito",
    "AMOUNT_GREATER_THEN_ALLOWED": "La cantidad que ha ingresado es mayor que la permitida.",
    "fund_msz": "depositar con éxito",
    "suceessMsz1": "2FA habilitado con éxito",
    "suceessMsz2": "2FA discapacitado con éxito",
    "suceessMsz3": "Se ha enviado un enlace para cambiar contraseña en su identificación de correo electrónico registrada",
    "suceessMsz4": "Contraseña cambiada con éxito",
    "suceessMsz5": "OTP se reinicia con éxito",
    "suceessMsz6": "OTP se envía en su correo electrónico de registro y número de teléfono móvil",
    "suceessMsz7": "Ahora eres elegible para abrir una cuenta en vivo",
    "suceessMsz8": "Sube tu documento dentro de los 15 días",
    "suceessMsz9": "Agregar nombre con éxito",
    "suceessMsz10": "El enlace ha sido enviado su identificación de correo electrónico registrada",
    "suceessMsz11": "planificar la suscripción con éxito",
    "suceessMsz12": "reiniciar el servicio correctamente",
    "suceessMsz13": "Reiniciar el servicio con éxito",
    "suceessMsz14": "apagado del servicio correctamente",
    "suceessMsz15": "Contraseña de servicio cambió correctamente",
    "suceessMsz16": "Se ha enviado un enlace a su dirección de correo electrónico registrada",
    "suceessMsz17": "depositar con éxito",
    "suceessMsz18": "OTP se reinicia con éxito",
    "suceessMsz19": "Agregar banco con éxito",
    "suceessMsz20": "El boleto se ha creado con éxito y espere 2-3 días hábiles",
    "suceessMsz21": "En este momento estamos permitiendo solo 1,00,000,00. En caso de que desee depositar más de este amable soporte de contacto",
    "suceessMsz22": "No se le permite ingresar el monto mayor o igual al límite de depósito, porque aún no está verificado y su documento aún está bajo verificación, por lo que no puede depositar más de 2000 EUR",
    "suceessMsz23": "Monto invalido",
    "suceessMsz24": "Su cuenta no está verificada",
    "suceessMsz25": "La ID de cuenta debe ser diferente de otra ID de cuenta que seleccionó",
    "suceessMsz26": "al menos seleccionar 2 opciones",
    "suceessMsz27": "nueva contraseña no es lo mismo que confirmar nueva contraseña",
    "suceessMsz28": "Su contraseña debe contener al menos 6 caracteres e incluir al menos 1 número, 1 carácter mayúscula y 1 carácter especial (!@#$%^&*/)",
    "errorMsz1": "¡Lo siento! Este enlace ha sido exoprado. Haga clic en <Router-Link: To = '/Forgot-Password'> ¡Aquí </router-link> para restablecer nuevamente!"
}


// WEBPACK FOOTER //
// ./src/plugins/lang/languages/es.js